var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tab-general-ui-custom" },
    [
      _vm.isFba
        ? _c(
            "el-form",
            {
              staticClass: "section",
              staticStyle: { "flex-direction": "row" },
              attrs: { disabled: !_vm.isEdit }
            },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    display: "flex",
                    "align-items": "center",
                    width: "64px"
                  }
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("FbaJob.ValueAddedServices")) + " "
                  )
                ]
              ),
              _c(
                "el-checkbox-group",
                {
                  attrs: { no: "selectedLocalAddedService" },
                  on: { change: _vm.addedServiceChangeHandler },
                  model: {
                    value: _vm.selectedLocalAddedService,
                    callback: function($$v) {
                      _vm.selectedLocalAddedService = $$v
                    },
                    expression: "selectedLocalAddedService"
                  }
                },
                _vm._l(_vm.localAddedService, function(item) {
                  return _c(
                    "el-checkbox",
                    {
                      key: item.code,
                      staticStyle: {
                        "margin-left": "8px",
                        "margin-right": "8px"
                      },
                      attrs: { label: item.code, no: "localAddedService" },
                      on: {
                        change: function(val) {
                          return _vm.singleAddedServiceChangeHandler(val, item)
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(item.chineseName) + " ")]
                  )
                }),
                1
              ),
              _vm.isAeBooking
                ? _c(
                    "el-checkbox",
                    {
                      staticStyle: {
                        "margin-left": "8px",
                        "margin-right": "8px"
                      },
                      attrs: { no: "destinationPortService" },
                      model: {
                        value: _vm.job.destinationPortService,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "destinationPortService", $$v)
                        },
                        expression: "job.destinationPortService"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("SeaExport.PortOfDestinationServices"))
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      !_vm.isFba
        ? _c(
            "el-form",
            {
              staticClass: "section",
              staticStyle: { "flex-direction": "row", "line-height": "28px" },
              attrs: { disabled: !_vm.isEdit }
            },
            [
              _c(
                "el-checkbox",
                {
                  attrs: { no: "49" },
                  model: {
                    value: _vm.job.virtualHBL,
                    callback: function($$v) {
                      _vm.$set(_vm.job, "virtualHBL", $$v)
                    },
                    expression: "job.virtualHBL"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.FormalHbl")))]
              ),
              _c(
                "el-checkbox",
                {
                  staticStyle: { "margin-left": "-20px" },
                  attrs: { no: "50" },
                  model: {
                    value: _vm.job.itmService,
                    callback: function($$v) {
                      _vm.$set(_vm.job, "itmService", $$v)
                    },
                    expression: "job.itmService"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.ForeignTrade")))]
              ),
              _vm.viewSource === "AeBooking"
                ? _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: ["button_insurance_toInsure"],
                          expression: "['button_insurance_toInsure']"
                        }
                      ],
                      class: _vm.viewStatus
                        ? "el-button el-button--primary el-button--mini"
                        : "el-button el-button--primary el-button--mini is-disabled",
                      staticStyle: {
                        "min-width": "46px!important",
                        "margin-left": "15px"
                      },
                      attrs: { id: "Insure", type: "primary", no: "129" },
                      on: {
                        click: function() {
                          if (_vm.viewStatus) {
                            _vm.pm.toInsure()
                          }
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Insure")) + " ")]
                  )
                : _vm._e(),
              !!_vm.templateName
                ? _c("div", { staticStyle: { "flex-grow": "1" } }, [
                    _c(
                      "span",
                      {
                        staticClass: "blue",
                        staticStyle: {
                          float: "right",
                          "margin-right": "30px",
                          padding: "0 5px",
                          "white-space": "nowrap"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("CargoMsg.Cargo_SopTemplate")) +
                            ": " +
                            _vm._s(_vm.templateName)
                        )
                      ]
                    )
                  ])
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-form",
        {
          ref: "basicForm",
          staticStyle: { display: "flex" },
          attrs: {
            disabled: _vm.viewStatus,
            "label-position": "right",
            "label-width": "120px"
          }
        },
        [
          _c(
            "tab-general-UICustom-layout",
            {
              attrs: {
                "element-blocks": _vm.elementBlocks,
                "element-dict": _vm.elementDict
              }
            },
            [
              _vm.elementDict.jobNo && _vm.elementDict.jobNo.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "jobNo" }, slot: "jobNo" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.jobNo.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.jobNo.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          no: "1",
                          disabled: true || !_vm.elementDict.jobNo.writable
                        },
                        model: {
                          value: _vm.job.jobNo,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "jobNo", $$v)
                          },
                          expression: "job.jobNo"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.operateType &&
              _vm.elementDict.operateType.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "operateType" }, slot: "operateType" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.operateType.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.operateType.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        class: _vm.importDifferenceField.operateType
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "2",
                          clearable: false,
                          filterable: "",
                          "select-type":
                            _vm.selectTypeNames
                              .local_cache_AirExportConstants$BUSINESS_MODELS,
                          "default-value": _vm.job.operateType,
                          disabled:
                            !_vm.operateTypeEnable ||
                            !_vm.elementDict.operateType.writable
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.operateTypeChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isZY
                ? [
                    _c(
                      "el-form-item",
                      {
                        attrs: { slot: "saleProductCode" },
                        slot: "saleProductCode"
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "blue",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.AllowSaleProduct")))]
                        ),
                        _c("cargo-advance-select", {
                          attrs: {
                            "select-type":
                              _vm.selectTypeNames.basic_data_AllowSaleProduct,
                            filterable: "",
                            no: "allowSaleProduct",
                            clearable: "",
                            "data-filter-function": function(p) {
                              if (!p.statusEnabled) {
                                return false
                              }
                              return _vm.isFba ? p.fbaAir : p.airExportEnabled
                            },
                            "default-value": this.job.saleProductCode || ""
                          },
                          on: {
                            parentCallBack: function(p) {
                              this$1.job.saleProductCode = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { slot: "fullOrInside" }, slot: "fullOrInside" },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "blue",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.FullOrInside")))]
                        ),
                        _c("cargo-advance-select", {
                          attrs: {
                            "select-type":
                              _vm.selectTypeNames
                                .local_cache_FullOrInside$FULL_OR_INSIDE,
                            no: "fullOrInside",
                            clearable: "",
                            "default-value": this.job.fullOrInside || ""
                          },
                          on: {
                            parentCallBack: function(p) {
                              this$1.job.fullOrInside = p.value
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                : _vm._e(),
              _vm.elementDict.customerId && _vm.elementDict.customerId.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "customerId" }, slot: "customerId" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.customerId.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.customerId.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center"
                          }
                        },
                        [
                          _c(
                            "el-tooltip",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.sopImageB,
                                  expression: "sopImageB"
                                }
                              ],
                              attrs: {
                                no: "3",
                                content: _vm.$t("SeaExport.SOPReceiver"),
                                placement: "right-end"
                              }
                            },
                            [
                              _c("img", {
                                staticClass: "sop-img",
                                class:
                                  _vm.job.customerId && _vm.viewStatus
                                    ? ""
                                    : "not-click",
                                staticStyle: {
                                  padding: "5px 0",
                                  "vertical-align": "bottom",
                                  cursor: "pointer"
                                },
                                attrs: {
                                  src: _vm.sopPic,
                                  width: "18",
                                  height: "28"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.pm.sopChangeCustomerIdHandler()
                                  }
                                }
                              })
                            ]
                          ),
                          _c(
                            "el-tooltip",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showWarningImageB,
                                  expression: "showWarningImageB"
                                }
                              ],
                              attrs: {
                                content: _vm.warningImageBTip,
                                placement: "right-end"
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-warning red",
                                staticStyle: { cursor: "pointer" }
                              })
                            ]
                          ),
                          !_vm.isFba
                            ? _c("cargo-sales-company-select", {
                                staticClass: "shipper-selector",
                                class: _vm.importDifferenceField.customerId
                                  ? "red-border"
                                  : "",
                                style: {
                                  width:
                                    _vm.showWarningImageB || _vm.sopImageB
                                      ? "180px"
                                      : "200px"
                                },
                                attrs: {
                                  no: "4",
                                  "popper-class": "shipper-selector-popper",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  "method-params": {
                                    customer: true,
                                    active: true,
                                    companyLob: "airExport"
                                  },
                                  "default-value": _vm.job.customerId || "",
                                  "check-credit": true,
                                  disabled:
                                    !_vm.customerEnabled ||
                                    !_vm.elementDict.customerId.writable,
                                  placeholder: " ",
                                  job: _vm.job
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.customerIdChange2ContractHandler(p)
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm.isFba
                            ? _c("cargo-company-select", {
                                staticClass: "shipper-selector",
                                style: {
                                  width:
                                    _vm.showWarningImageB || _vm.sopImageB
                                      ? "180px"
                                      : "200px"
                                },
                                attrs: {
                                  no: "customerId",
                                  "popper-class": "shipper-selector-popper",
                                  "method-params": {
                                    customer: true,
                                    companyLob: "airExport",
                                    active: true,
                                    fba: true
                                  },
                                  "check-credit": true,
                                  job: _vm.job,
                                  "default-value": _vm.job.customerId || "",
                                  disabled:
                                    !_vm.customerEnabled ||
                                    !_vm.elementDict.customerId.writable,
                                  "data-filter-function":
                                    _vm.fbaCustomerIdFilter,
                                  placeholder: " "
                                },
                                on: {
                                  change: function(p) {
                                    _vm.customerIdChange2ContractHandler(p)
                                    _vm.clearPoNo()
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.customerLevel &&
              _vm.elementDict.customerLevel.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "customerLevel" }, slot: "customerLevel" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.customerLevel.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.customerLevel.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: _vm.customerTip,
                            placement: "bottom"
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.customerLevel.customerName,
                                  expression: "customerLevel.customerName"
                                }
                              ],
                              staticStyle: { color: "#FD9A14" }
                            },
                            [_vm._v("LV" + _vm._s(_vm.customerLevel.level))]
                          ),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.customerLevel.customerName,
                                  expression: "customerLevel.customerName"
                                }
                              ],
                              staticStyle: { color: "#D3A73B" }
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.customerLevel.customerName)
                              )
                            ]
                          ),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.contractStatusLabel,
                                  expression: "contractStatusLabel"
                                }
                              ],
                              staticStyle: { color: "red" }
                            },
                            [
                              _vm._v(
                                " (" + _vm._s(_vm.contractStatusLabel) + ")"
                              )
                            ]
                          ),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.advancePaymentLabel,
                                  expression: "advancePaymentLabel"
                                }
                              ],
                              staticStyle: { color: "firebrick" }
                            },
                            [
                              _vm._v(
                                " (" + _vm._s(_vm.advancePaymentLabel) + ")"
                              )
                            ]
                          ),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.stampPictureView.businessDocuments
                                      .length > 0,
                                  expression:
                                    "stampPictureView.businessDocuments.length > 0"
                                }
                              ],
                              on: {
                                click: function($event) {
                                  _vm.stampPictureView.visible = true
                                }
                              }
                            },
                            [
                              _c("img", {
                                staticStyle: { "text-align": "right" },
                                attrs: {
                                  title: _vm.$t("Message.BookingSeal"),
                                  src: _vm.stampIcon,
                                  height: "14"
                                }
                              })
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.dispatchingPlace &&
              _vm.elementDict.dispatchingPlace.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "dispatchingPlace" },
                      slot: "dispatchingPlace"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.dispatchingPlace.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.dispatchingPlace.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        class: _vm.importDifferenceField.dispatchingPlace
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "dispatchingPlace",
                          disabled: !_vm.elementDict.dispatchingPlace.writable
                        },
                        model: {
                          value: _vm.job.dispatchingPlace,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "dispatchingPlace", $$v)
                          },
                          expression: "job.dispatchingPlace"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.elementDict.loadingPortCode &&
                        _vm.elementDict.loadingPortCode.viewable,
                      expression:
                        "elementDict.loadingPortCode && elementDict.loadingPortCode.viewable"
                    }
                  ],
                  attrs: { slot: "loadingPortCode" },
                  slot: "loadingPortCode"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.loadingPortCode.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.loadingPortCode.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between"
                      }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "60px", "margin-right": "5px" },
                        attrs: {
                          no: "5",
                          value: _vm.loading3Code,
                          disabled: true
                        }
                      }),
                      _c("cargo-advance-select", {
                        ref: "loadingPortCode",
                        class: _vm.importDifferenceField.loadingPortCode
                          ? "red-border"
                          : "",
                        staticStyle: { flex: "1" },
                        attrs: {
                          no: "6",
                          filterable: "",
                          "select-type": _vm.selectTypeNames.basic_data_Airport,
                          "default-value": _vm.job.loadingPortCode,
                          "tag-name": "englishName",
                          disabled:
                            !!_vm.job.lclMasterUuid ||
                            !_vm.elementDict.loadingPortCode.writable,
                          placeholder: " "
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.loadingPortCodeChange(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.elementDict.destinationPortCode &&
              _vm.elementDict.destinationPortCode.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "destinationPortCode" },
                      slot: "destinationPortCode"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.destinationPortCode.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.destinationPortCode.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c("el-input", {
                            staticStyle: {
                              width: "60px",
                              "margin-right": "5px"
                            },
                            attrs: {
                              no: "7",
                              value: _vm.destination3Code,
                              disabled: true
                            }
                          }),
                          _c("cargo-advance-select", {
                            class: _vm.importDifferenceField.destinationPortCode
                              ? "red-border"
                              : "",
                            staticStyle: { flex: "1" },
                            attrs: {
                              no: "8",
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Airport,
                              "default-value": _vm.job.destinationPortCode,
                              disabled:
                                !!_vm.job.lclMasterUuid ||
                                !_vm.elementDict.destinationPortCode.writable,
                              placeholder: " "
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.pm.destinationPortCodeChange(p)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.destinationPlace &&
              _vm.elementDict.destinationPlace.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "destinationPlace" },
                      slot: "destinationPlace"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.destinationPlace.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.destinationPlace.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c("el-input", {
                            class: _vm.importDifferenceField.destinationPlace
                              ? "red-border"
                              : "",
                            attrs: {
                              disabled: !_vm.elementDict.destinationPlace
                                .writable,
                              no: "9"
                            },
                            on: {
                              input: function(val) {
                                return _vm.pm.destinationPlaceChange(val)
                              }
                            },
                            model: {
                              value: _vm.job.destinationPlace,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "destinationPlace", $$v)
                              },
                              expression: "job.destinationPlace"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.vesselLine && _vm.elementDict.vesselLine.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "vesselLine" }, slot: "vesselLine" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.vesselLine.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.vesselLine.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          no: "10",
                          disabled: true || !_vm.elementDict.vesselLine.writable
                        },
                        model: {
                          value: _vm.vesselLine,
                          callback: function($$v) {
                            _vm.vesselLine = $$v
                          },
                          expression: "vesselLine"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.transfering &&
              _vm.elementDict.transfering.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "transfering" }, slot: "transfering" },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: {
                                disabled: !_vm.elementDict.transfering.writable,
                                no: "11"
                              },
                              model: {
                                value: _vm.job.transfering,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "transfering", $$v)
                                },
                                expression: "job.transfering"
                              }
                            },
                            [_vm._v(_vm._s(_vm.elementDict.transfering.label))]
                          ),
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                display: "inline-block",
                                width: "100%",
                                overflow: "hidden",
                                "text-overflow": "ellipsis",
                                "margin-left": "2px"
                              },
                              attrs: {
                                no: "12",
                                disabled:
                                  _vm.viewStatus ||
                                  (!_vm.viewStatus && !_vm.job.transfering) ||
                                  !_vm.elementDict.transfering.writable,
                                title: _vm.$t("SeaExport.EnterTransitInfo"),
                                type: "primary"
                              },
                              on: { click: _vm.setTransferingHandler }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("SeaExport.EnterTransitInfo")) +
                                  " "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e(),
              _vm.elementDict.cargoSource &&
              _vm.elementDict.cargoSource.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "cargoSource" }, slot: "cargoSource" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.cargoSource.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.cargoSource.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            class: _vm.importDifferenceField.cargoSource
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "13",
                              clearable: false,
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.local_cache_CargoSource,
                              "default-value": _vm.job.cargoSource,
                              disabled: !_vm.elementDict.cargoSource.writable,
                              fields: ["chineseName"]
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.pm.cargoSourceChangeHandler(p)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.serviceProduct &&
              _vm.elementDict.serviceProduct.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "serviceProduct" },
                      slot: "serviceProduct"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.serviceProduct.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.serviceProduct.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "145",
                              clearable: false,
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames
                                  .basic_data_AirServiceProduct,
                              "callback-method-type": "value",
                              "default-value": _vm.job.serviceProduct,
                              "callback-params": { key: "serviceProduct" },
                              disabled: !_vm.elementDict.serviceProduct.writable
                            },
                            on: { parentCallBack: _vm.setJobSelectValue }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.airlineProductUuid &&
              _vm.elementDict.airlineProductUuid.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "airlineProductUuid" },
                      slot: "airlineProductUuid"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.airlineProductUuid.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.airlineProductUuid.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "airlineProductUuid",
                              filterable: "",
                              "static-options": _vm.airlineProductDownList,
                              "method-params": { active: true },
                              "tag-value": "uuid",
                              "tag-name": "name",
                              "filter-tag-names": ["name"],
                              "static-component": new _vm.AutoComplete(),
                              "callback-method-type": "value",
                              "default-value": _vm.job.airlineProductUuid,
                              "callback-params": { key: "airlineProductUuid" },
                              disabled: !_vm.elementDict.airlineProductUuid
                                .writable
                            },
                            on: { parentCallBack: _vm.setJobSelectValue }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.customJobType &&
              _vm.elementDict.customJobType.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "customJobType" }, slot: "customJobType" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.customJobType.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.customJobType.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        class: _vm.importDifferenceField.customJobType
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "14",
                          filterable: "",
                          "select-type":
                            _vm.selectTypeNames.basic_data_CutomJobType,
                          "method-params": { type: _vm.job.lob },
                          "default-value": _vm.job.customJobType,
                          "static-options": _vm.customJobTypeList,
                          placeholder: " ",
                          disabled: !_vm.elementDict.customJobType.writable
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.customJobType = p.value
                            _vm.oncustomJobTypeChange(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.elementDict.secondaryCustomJobType &&
                        _vm.elementDict.secondaryCustomJobType.viewable &&
                        _vm.job.customJobType &&
                        _vm.secondaryCustomJobTypeList.length > 0,
                      expression:
                        "elementDict.secondaryCustomJobType && elementDict.secondaryCustomJobType.viewable && job.customJobType && secondaryCustomJobTypeList.length > 0"
                    }
                  ],
                  attrs: { slot: "secondaryCustomJobType" },
                  slot: "secondaryCustomJobType"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.secondaryCustomJobType.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.secondaryCustomJobType.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    ref: "secondaryCustomJobType",
                    attrs: {
                      no: "secondaryCustomJobType",
                      "select-type":
                        _vm.selectTypeNames.basic_data_CutomJobType,
                      filterable: "",
                      cache: false,
                      "default-value": _vm.job.secondaryCustomJobType,
                      "tag-name": _vm.isZh ? "name" : "englishName",
                      "static-options": _vm.secondaryCustomJobTypeList,
                      disabled: !_vm.elementDict.secondaryCustomJobType.writable
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.secondaryCustomJobType = p.value
                      }
                    }
                  })
                ],
                1
              ),
              _vm.elementDict.appraisalCategory &&
              _vm.elementDict.appraisalCategory.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "appraisalCategory" },
                      slot: "appraisalCategory"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.appraisalCategory.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.appraisalCategory.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "146",
                          filterable: "",
                          "select-type":
                            _vm.selectTypeNames.basic_data_AppraisalCategory,
                          "default-value": _vm.job.appraisalCategory,
                          placeholder: " ",
                          disabled: !_vm.elementDict.appraisalCategory.writable
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.appraisalCategory = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.localAgent && _vm.elementDict.localAgent.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "localAgent" }, slot: "localAgent" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.localAgent.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.localAgent.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        class: _vm.importDifferenceField.localAgent
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "15",
                          filterable: "",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "method-params": { localAgent: true, active: true },
                          "default-value": _vm.job.localAgent || "",
                          placeholder: " ",
                          disabled: !_vm.elementDict.localAgent.writable
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.localAgentChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.destinationAgent &&
              _vm.elementDict.destinationAgent.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "destinationAgent" },
                      slot: "destinationAgent"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.destinationAgent.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.destinationAgent.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center"
                          }
                        },
                        [
                          _c(
                            "el-tooltip",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showWarningImageC,
                                  expression: "showWarningImageC"
                                }
                              ],
                              attrs: {
                                content: _vm.warningImageCTip,
                                placement: "right-end"
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-warning",
                                staticStyle: { color: "red" }
                              })
                            ]
                          ),
                          _c("cargo-advance-select", {
                            class: _vm.importDifferenceField.destinationAgent
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "16",
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Company,
                              "method-params": {
                                overseaAgent: true,
                                active: true
                              },
                              "default-value": _vm.job.destinationAgent || "",
                              "tag-name": "englishName",
                              placeholder: " ",
                              disabled: !_vm.elementDict.destinationAgent
                                .writable
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.pm.destinationAgentChangeHandler(p)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.designationAgent &&
              _vm.elementDict.designationAgent.viewable &&
              _vm.job.cargoSource === "NC"
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "designationAgent" },
                      slot: "designationAgent"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.designationAgent.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.designationAgent.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center"
                          }
                        },
                        [
                          _c(
                            "el-tooltip",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.sopImageA,
                                  expression: "sopImageA"
                                }
                              ],
                              attrs: {
                                no: "17",
                                content: _vm.$t("SeaExport.SOPReceiver"),
                                placement: "right-end"
                              }
                            },
                            [
                              _c("div", [
                                _c("img", {
                                  staticClass: "sop-img",
                                  class:
                                    _vm.job.designationAgent && _vm.viewStatus
                                      ? ""
                                      : "not-click",
                                  staticStyle: {
                                    padding: "5px 0",
                                    cursor: "pointer"
                                  },
                                  attrs: {
                                    src: _vm.sopPic,
                                    width: "18",
                                    height: "28",
                                    no: "designationAgent"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.sopChangeBookingAgentHandler()
                                    }
                                  }
                                })
                              ])
                            ]
                          ),
                          _c(
                            "el-tooltip",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showWarningImageA,
                                  expression: "showWarningImageA"
                                }
                              ],
                              attrs: {
                                content: _vm.warningImageATip,
                                placement: "right-end"
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-warning",
                                staticStyle: { color: "red", cursor: "pointer" }
                              })
                            ]
                          ),
                          _c("cargo-advance-select", {
                            staticClass: "designation-agent-selector",
                            class: _vm.importDifferenceField.designationAgent
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "18",
                              "popper-class":
                                "designation-agent-selector-popper",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Company,
                              disabled:
                                !_vm.designationAgentEnabled ||
                                !_vm.elementDict.designationAgent.writable,
                              "method-params": {
                                designationAgent: true,
                                active: true
                              },
                              "check-credit": true,
                              "default-value": _vm.job.designationAgent || "",
                              filterable: "",
                              headers: [_vm.$t("Partners.englishName")],
                              fields: ["englishName"],
                              "tag-name": "englishName",
                              placeholder: " "
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.pm.designationAgentChangeHandler(p)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.exChangeAgent &&
              _vm.elementDict.exChangeAgent.viewable &&
              _vm.job.cargoSource === "NC"
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "exChangeAgent" }, slot: "exChangeAgent" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.exChangeAgent.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.exChangeAgent.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-company-select", {
                        class: _vm.importDifferenceField.exChangeAgent
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "exChangeAgent",
                          disabled:
                            !_vm.job.dischargingPortDoor ||
                            !_vm.elementDict.exChangeAgent.writable,
                          "method-params": { bookingAgent: true, active: true },
                          "default-value": _vm.job.exChangeAgent || ""
                        },
                        on: { change: _vm.onExChangeAgentChange }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.bookingAgent &&
              _vm.elementDict.bookingAgent.viewable &&
              _vm.bookingAgentVisible
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "bookingAgent" }, slot: "bookingAgent" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.bookingAgent.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.bookingAgent.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        class: _vm.importDifferenceField.bookingAgent
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "19",
                          filterable: "",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "method-params": { bookingAgent: true, active: true },
                          "default-value": _vm.job.bookingAgent || "",
                          disabled:
                            !_vm.bookingAgentEnabled ||
                            !_vm.elementDict.bookingAgent.writable,
                          placeholder: " "
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.bookingAgentChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.fileCutoff && _vm.elementDict.fileCutoff.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "fileCutoff" }, slot: "fileCutoff" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.fileCutoff.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.fileCutoff.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        ref: "fileCutoff",
                        class: _vm.importDifferenceField.fileCutoff
                          ? "red-border"
                          : "",
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "20",
                          disabled:
                            !!_vm.job.lclMasterUuid ||
                            !_vm.elementDict.fileCutoff.writable,
                          clearable: "",
                          type: "datetime",
                          format: "yyyy-MM-dd HH:mm",
                          "value-format": "yyyy-MM-dd HH:mm"
                        },
                        on: {
                          blur: function() {
                            _vm.handleBlur(
                              "fileCutoff",
                              null,
                              true,
                              false,
                              _vm.job
                            )
                          }
                        },
                        model: {
                          value: _vm.job.fileCutoff,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "fileCutoff", $$v)
                          },
                          expression: "job.fileCutoff"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.mbl && _vm.elementDict.mbl.viewable
                ? _c(
                    "template",
                    { slot: "mbl" },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("line-label", {
                            class: _vm.elementDict.mbl.isRequire ? "blue" : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.mbl.label
                            },
                            slot: "label"
                          }),
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { "margin-right": "2px" },
                              attrs: {
                                disabled: !_vm.elementDict.mbl.writable,
                                no: "122"
                              },
                              on: { change: _vm.expressChangeHandler },
                              model: {
                                value: _vm.job.express,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "express", $$v)
                                },
                                expression: "job.express"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.ExpressInfo")))]
                          ),
                          _vm.job.express
                            ? _c("el-input", {
                                staticStyle: { width: "130px" },
                                attrs: {
                                  disabled: !_vm.elementDict.mbl.writable,
                                  no: "21"
                                },
                                on: { change: _vm.mblChange },
                                model: {
                                  value: _vm.job.mbl,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "mbl", $$v)
                                  },
                                  expression: "job.mbl"
                                }
                              })
                            : _vm._e(),
                          _c("mawb-no-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.job.express,
                                expression: "!job.express"
                              }
                            ],
                            ref: "mawbNoInput",
                            attrs: {
                              no: "22",
                              editable:
                                _vm.isEditablemawbNoInput ||
                                !_vm.elementDict.mbl.writable
                            },
                            on: {
                              change: _vm.mblChangeEvent,
                              changeCallback: function($event) {
                                return _vm.mblCheckHandler(true)
                              }
                            },
                            model: {
                              value: _vm.job.mbl,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "mbl", $$v)
                              },
                              expression: "job.mbl"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                no: "23",
                                disabled: !_vm.propertiesEnabled
                                  .selectBtnEnabled,
                                type: "primary"
                              },
                              on: { click: _vm.openMAWBHandler }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Select")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                no: "24",
                                disabled: !_vm.propertiesEnabled
                                  .newConsoleBtnEnabled,
                                type: "primary"
                              },
                              on: { click: _vm.newConsoleHandler }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.New")))]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                no: "25",
                                disabled: !_vm.propertiesEnabled
                                  .attachBtnEnabled,
                                type: "primary"
                              },
                              on: { click: _vm.attachMAWBHandler }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Add3")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                no: "26",
                                disabled: !_vm.propertiesEnabled
                                  .deattachBtnEnabled,
                                type: "primary"
                              },
                              on: { click: _vm.deattachMAWBHandler }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Separate")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.jobSoNo && _vm.elementDict.jobSoNo.viewable
                ? _c(
                    "template",
                    { slot: "jobSoNo" },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("line-label", {
                            class: _vm.elementDict.jobSoNo.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.jobSoNo.label
                            },
                            slot: "label"
                          }),
                          _c("so-no-input", {
                            attrs: {
                              no: "27",
                              disabled:
                                _vm.viewStatus ||
                                !_vm.elementDict.jobSoNo.writable
                            },
                            model: {
                              value: _vm.job.jobSoNo,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "jobSoNo", $$v)
                              },
                              expression: "job.jobSoNo"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: {
                                disabled: !_vm.elementDict.jobSoNo.writable,
                                no: "28"
                              },
                              model: {
                                value: _vm.job.predictionOperation,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "predictionOperation", $$v)
                                },
                                expression: "job.predictionOperation"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.PreAlertOperation"))
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.portOfDestinationServices &&
              _vm.elementDict.portOfDestinationServices.viewable &&
              !_vm.isFba &&
              _vm.isAeBooking
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "portOfDestinationServices" },
                      slot: "portOfDestinationServices"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.portOfDestinationServices
                          .isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.portOfDestinationServices.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "el-checkbox",
                        {
                          staticClass: "checkbox-content",
                          attrs: {
                            no: "dischargingPortDoor",
                            title: _vm.$t(
                              "SeaExport.DispatchVehiclesAtDestination"
                            )
                          },
                          on: { change: _vm.dischargingPortDoorClick },
                          model: {
                            value: _vm.job.dischargingPortDoor,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "dischargingPortDoor", $$v)
                            },
                            expression: "job.dischargingPortDoor"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("SeaExport.DispatchVehiclesAtDestination")
                            ) + " "
                          )
                        ]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          staticClass: "checkbox-content",
                          attrs: {
                            no: "usCustomsClearance",
                            title: _vm.$t("queryJob.UsCustomsClearance")
                          },
                          model: {
                            value: _vm.job.usCustomsClearance,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "usCustomsClearance", $$v)
                            },
                            expression: "job.usCustomsClearance"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("queryJob.UsCustomsClearance")) + " "
                          )
                        ]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          staticClass: "checkbox-content",
                          attrs: {
                            no: "destPortCustomsClearance",
                            title: _vm.$t(
                              "SeaExport.PortOfDestinationCustomsClearance"
                            )
                          },
                          model: {
                            value: _vm.job.destPortCustomsClearance,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "destPortCustomsClearance", $$v)
                            },
                            expression: "job.destPortCustomsClearance"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "SeaExport.PortOfDestinationCustomsClearance"
                              )
                            ) + " "
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.customerContact &&
              _vm.elementDict.customerContact.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        slot: "customerContact",
                        "label-width": "120px"
                      },
                      slot: "customerContact"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.customerContact.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.customerContact.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              class: _vm.importDifferenceField.customerContact
                                ? "red-border"
                                : "",
                              attrs: {
                                disabled: !_vm.elementDict.customerContact
                                  .writable,
                                no: "29",
                                filterable: "",
                                "allow-create": true,
                                placeholder: " "
                              },
                              model: {
                                value: _vm.job.customerContact,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "customerContact", $$v)
                                },
                                expression: "job.customerContact"
                              }
                            },
                            _vm._l(_vm.contactList, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.contactPerson,
                                  value: item.contactPerson
                                }
                              })
                            }),
                            1
                          ),
                          _c(
                            "el-link",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.isShowContactPersonDetail,
                                  expression: "!isShowContactPersonDetail"
                                }
                              ],
                              staticStyle: { width: "80px" },
                              attrs: { no: "30" },
                              on: {
                                click: function($event) {
                                  _vm.showContactsInfoDialog = true
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Detail")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.contactTelephone &&
              _vm.elementDict.contactTelephone.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        slot: "contactTelephone",
                        "label-width": "120px"
                      },
                      slot: "contactTelephone"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.contactTelephone.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.contactTelephone.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        class: _vm.importDifferenceField.contactTelephone
                          ? "red-border"
                          : "",
                        attrs: {
                          disabled: !_vm.elementDict.contactTelephone.writable,
                          no: "31"
                        },
                        model: {
                          value: _vm.job.contactTelephone,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "contactTelephone", $$v)
                          },
                          expression: "job.contactTelephone"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.contactFax && _vm.elementDict.contactFax.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "contactFax", "label-width": "120px" },
                      slot: "contactFax"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.contactFax.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.contactFax.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        class: _vm.importDifferenceField.contactFax
                          ? "red-border"
                          : "",
                        attrs: {
                          disabled: !_vm.elementDict.contactFax.writable,
                          no: "32"
                        },
                        model: {
                          value: _vm.job.contactFax,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "contactFax", $$v)
                          },
                          expression: "job.contactFax"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.loadingTerm &&
              _vm.elementDict.loadingTerm.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "loadingTerm", "label-width": "120px" },
                      slot: "loadingTerm"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.loadingTerm.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.loadingTerm.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        ref: "loadingTerm",
                        class: _vm.importDifferenceField.loadingTerm
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "33",
                          filterable: "",
                          "select-type":
                            _vm.selectTypeNames
                              .local_cache_AirExportConstants$SUFFY_TYPES,
                          "callback-method-type": "value",
                          "default-value": _vm.job.loadingTerm,
                          fields: ["chineseName"],
                          "tag-name": _vm.isZh ? "chineseName" : "englishName",
                          "callback-params": { key: "loadingTerm" },
                          placeholder: " ",
                          disabled: !_vm.elementDict.loadingTerm.writable
                        },
                        on: { parentCallBack: _vm.setJobSelectValue }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isFba && _vm.isAeBooking && _vm.job.destinationPortService
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.PortOfDestinationServices")
                      }
                    },
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          attrs: { no: "123" },
                          on: { change: _vm.addedServiceChangeHandler },
                          model: {
                            value: _vm.selectedPodAddedService,
                            callback: function($$v) {
                              _vm.selectedPodAddedService = $$v
                            },
                            expression: "selectedPodAddedService"
                          }
                        },
                        _vm._l(_vm.podAddedService, function(item) {
                          return _c(
                            "el-checkbox",
                            {
                              key: item.code,
                              staticStyle: { display: "block" },
                              attrs: { label: item.code, no: "124" },
                              on: {
                                change: function(val) {
                                  return _vm.singleAddedServiceChangeHandler(
                                    val,
                                    item
                                  )
                                }
                              }
                            },
                            [_vm._v(" " + _vm._s(item.chineseName) + " ")]
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.quotationNo &&
              _vm.elementDict.quotationNo.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "quotationNo", "label-width": "120px" },
                      slot: "quotationNo"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.quotationNo.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.quotationNo.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          no: "34",
                          value: _vm.job.quotationNo,
                          disabled: true
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.bookingTerm &&
              _vm.elementDict.bookingTerm.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "bookingTerm", "label-width": "120px" },
                      slot: "bookingTerm"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.bookingTerm.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.bookingTerm.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        class: _vm.importDifferenceField.bookingTerm
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "35",
                          filterable: "",
                          clearable: false,
                          "select-type":
                            _vm.selectTypeNames.local_cache_BookingTerm,
                          "default-value": _vm.job.bookingTerm,
                          disabled:
                            !_vm.propertiesEnabled.bookingTermEnabled ||
                            !_vm.elementDict.bookingTerm.writable,
                          fields: ["chineseName"]
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.bookingTermChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.customClaim &&
              _vm.elementDict.customClaim.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "customClaim", "label-width": "120px" },
                      slot: "customClaim"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.customClaim.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.customClaim.label
                        },
                        slot: "label"
                      }),
                      !_vm.isFba
                        ? _c("cargo-advance-select", {
                            class: _vm.importDifferenceField.customClaim
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "36",
                              "select-type":
                                _vm.selectTypeNames.basic_data_CustomsMode,
                              "method-params": { serviceType: 2 },
                              "tag-value": "serialNum",
                              filterable: "",
                              "default-value": _vm.job.customClaim,
                              disabled: !_vm.elementDict.customClaim.writable
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.job.customClaim = p.value
                              }
                            }
                          })
                        : _vm._e(),
                      _vm.isFba
                        ? _c("cargo-advance-select", {
                            attrs: {
                              no: "customsMethodPol",
                              "select-type":
                                _vm.selectTypeNames.basic_data_CustomsMode,
                              "method-params": { serviceType: 0 },
                              filterable: "",
                              clearable: false,
                              "default-value": _vm.fbaJob.customsMethodPol
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.fbaJob.customsMethodPol = p.value
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isFba
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("AirExport.CustomsClearanceMethod"),
                        "label-width": "120px"
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "customsMethodPod",
                          "select-type":
                            _vm.selectTypeNames.basic_data_CustomsMode,
                          "method-params": { serviceType: 1 },
                          filterable: "",
                          clearable: false,
                          "default-value": _vm.fbaJob.customsMethodPod
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.fbaJob.customsMethodPod = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.customsClaim2 &&
              _vm.elementDict.customsClaim2.viewable &&
              Number(_vm.job.customClaim) === 1
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "customsClaim2", "label-width": "120px" },
                      slot: "customsClaim2"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.customsClaim2.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.customsClaim2.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "37",
                          filterable: "",
                          "select-type":
                            _vm.selectTypeNames
                              .basic_data_CustomsDeclarationType,
                          "default-value": _vm.job.customsClaim2 || 0,
                          disabled: !_vm.elementDict.customsClaim2.writable
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.customsClaim2 = p.value
                            _vm.job.customsDeclarationType = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.tradeTerm && _vm.elementDict.tradeTerm.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "tradeTerm", "label-width": "120px" },
                      slot: "tradeTerm"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.tradeTerm.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.tradeTerm.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        class: _vm.importDifferenceField.tradeTerm
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "38",
                          filterable: "",
                          clearable: false,
                          disabled: !_vm.elementDict.tradeTerm.writable,
                          "select-type":
                            _vm.selectTypeNames.basic_data_TradeTerm,
                          "callback-method-type": "value",
                          "default-value": _vm.job.tradeTerm,
                          "callback-params": { key: "tradeTerm" }
                        },
                        on: { parentCallBack: _vm.setJobSelectValue }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.declareCustomsState &&
              _vm.elementDict.declareCustomsState.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        slot: "declareCustomsState",
                        "label-width": "120px"
                      },
                      slot: "declareCustomsState"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.declareCustomsState.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.declareCustomsState.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        class: _vm.importDifferenceField.declareCustomsState
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "39",
                          filterable: "",
                          disabled:
                            false ||
                            !_vm.elementDict.declareCustomsState.writable,
                          "select-type":
                            _vm.selectTypeNames
                              .local_cache_SystemConstants$DECLARE_CUSTOMS_STATE,
                          "default-value": _vm.job.declareCustomsState || "",
                          "tag-name": _vm.isZh ? "chineseName" : "englishName",
                          fields: ["chineseName"]
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.declareCustomsState = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.incoTerm && _vm.elementDict.incoTerm.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "incoTerm", "label-width": "120px" },
                      slot: "incoTerm"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.incoTerm.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.incoTerm.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        class: _vm.importDifferenceField.incoTerm
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "40",
                          filterable: "",
                          clearable: false,
                          disabled: !_vm.elementDict.incoTerm.writable,
                          "select-type":
                            _vm.selectTypeNames.basic_data_IncoTerm,
                          "callback-method-type": "value",
                          "default-value": _vm.job.incoTerm,
                          "callback-params": { key: "incoTerm" },
                          placeholder: " "
                        },
                        on: { parentCallBack: _vm.setJobSelectValue }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.carrierId && _vm.elementDict.carrierId.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "carrierId", "label-width": "120px" },
                      slot: "carrierId"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.carrierId.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.carrierId.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        class: _vm.importDifferenceField.carrierId
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "41",
                          filterable: "",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "method-params": {
                            airCmp: true,
                            companyLob: "airExport",
                            active: true
                          },
                          "default-value": _vm.job.carrierId || "",
                          headers: [
                            _vm.$t("Tool.ShortName"),
                            _vm.$t("Partners.chineseName")
                          ],
                          fields: ["shortName", "chineseName"],
                          disabled:
                            !_vm.airlineCompanyEnabled ||
                            !_vm.elementDict.carrierId.writable,
                          placeholder: " "
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.airlineCompanyChangeHandler(p.value || 0)
                            _vm.pm.airlineCompanyChange(p.value || 0)
                            _vm.airlineCompanyCheckHandler(p.value || 0)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.carrierWebsite &&
              _vm.elementDict.carrierWebsite.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "carrierWebsite" },
                      slot: "carrierWebsite"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.carrierWebsite.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.carrierWebsite.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-textarea", {
                        attrs: {
                          no: "carrierWebsite",
                          type: "textarea",
                          row: 3,
                          disabled: !_vm.elementDict.carrierWebsite.writable
                        },
                        model: {
                          value: _vm.job.carrierWebsite,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "carrierWebsite", $$v)
                          },
                          expression: "job.carrierWebsite"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.voyageFlight &&
              _vm.elementDict.voyageFlight.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "voyageFlight", "label-width": "120px" },
                      slot: "voyageFlight"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.voyageFlight.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.voyageFlight.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        class: _vm.importDifferenceField.voyageFlight
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "42",
                          disabled:
                            !_vm.flightEnabled ||
                            !_vm.elementDict.voyageFlight.writable
                        },
                        on: { change: _vm.voyageFlightCheckHandler },
                        model: {
                          value: _vm.job.voyageFlight,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "voyageFlight", $$v)
                          },
                          expression: "job.voyageFlight"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.customsDate &&
              _vm.elementDict.customsDate.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "customsDate", "label-width": "120px" },
                      slot: "customsDate"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.customsDate.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.customsDate.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        class: _vm.importDifferenceField.customsDate
                          ? "red-border"
                          : "",
                        staticStyle: { width: "100%" },
                        attrs: {
                          disabled: !_vm.elementDict.customsDate.writable,
                          no: "43",
                          type: "date",
                          "value-format": "yyyy-MM-dd",
                          clearable: ""
                        },
                        model: {
                          value: _vm.job.customsDate,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "customsDate", $$v)
                          },
                          expression: "job.customsDate"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.etd && _vm.elementDict.etd.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "etd", "label-width": "120px" },
                      slot: "etd"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.etd.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.etd.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-date-picker", {
                            ref: "etd",
                            class: _vm.importDifferenceField.etd
                              ? "red-border"
                              : "",
                            staticStyle: {
                              flex: "1",
                              width: "170px",
                              "margin-right": "5px"
                            },
                            attrs: {
                              value: _vm.job.etd,
                              no: "44",
                              disabled:
                                !!_vm.job.lclMasterUuid ||
                                !_vm.elementDict.etd.writable ||
                                _vm.provisionEtdLocked,
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm",
                              format: "yyyy-MM-dd HH:mm",
                              clearable: ""
                            },
                            on: {
                              input: _vm.etdChange,
                              blur: function() {
                                _vm.handleBlur(
                                  "etd",
                                  _vm.etdChange,
                                  false,
                                  false,
                                  _vm.job
                                )
                              }
                            }
                          }),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm._f("filterWeek")(_vm.job.sailingDay))
                            )
                          ])
                        ],
                        1
                      ),
                      _vm.provisionEtdLocked
                        ? _c(
                            "span",
                            {
                              staticStyle: { color: "red", "font-size": "12px" }
                            },
                            [_vm._v("(已计提校准不可修改)")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.eta && _vm.elementDict.eta.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "eta", "label-width": "120px" },
                      slot: "eta"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.eta.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.eta.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-date-picker", {
                            ref: "eta",
                            class: _vm.importDifferenceField.eta
                              ? "red-border"
                              : "",
                            staticStyle: {
                              flex: "1",
                              width: "170px",
                              "margin-right": "5px"
                            },
                            attrs: {
                              no: "45",
                              disabled:
                                !!_vm.job.lclMasterUuid ||
                                !_vm.elementDict.eta.writable,
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm",
                              format: "yyyy-MM-dd HH:mm",
                              clearable: ""
                            },
                            on: {
                              input: _vm.etaChange,
                              blur: function() {
                                _vm.handleBlur(
                                  "eta",
                                  _vm.etaChange,
                                  false,
                                  false,
                                  _vm.job
                                )
                              }
                            },
                            model: {
                              value: _vm.job.eta,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "eta", $$v)
                              },
                              expression: "job.eta"
                            }
                          }),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("filterWeek")(_vm.job.etaSailingDay)
                              )
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.atd && _vm.elementDict.atd.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "atd", "label-width": "120px" },
                      slot: "atd"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.atd.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.atd.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-date-picker", {
                            ref: "atd",
                            staticStyle: {
                              flex: "1",
                              width: "170px",
                              "margin-right": "5px"
                            },
                            attrs: {
                              value: _vm.job.atd,
                              no: "46",
                              disabled:
                                !!_vm.job.lclMasterUuid ||
                                !_vm.elementDict.atd.writable,
                              clearable: "",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            on: {
                              input: _vm.atdChange,
                              blur: function() {
                                _vm.handleBlur(
                                  "atd",
                                  _vm.atdChange,
                                  false,
                                  false,
                                  _vm.job
                                )
                              }
                            }
                          }),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("filterWeek")(_vm.job.atdSailingDay)
                              )
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.ata && _vm.elementDict.ata.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "ata", "label-width": "120px" },
                      slot: "ata"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.ata.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.ata.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-date-picker", {
                            ref: "ata",
                            staticStyle: {
                              flex: "1",
                              width: "170px",
                              "margin-right": "5px"
                            },
                            attrs: {
                              no: "47",
                              disabled:
                                !!_vm.job.lclMasterUuid ||
                                !_vm.elementDict.ata.writable,
                              clearable: "",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            on: {
                              input: _vm.ataChange,
                              blur: function() {
                                _vm.handleBlur(
                                  "ata",
                                  _vm.ataChange,
                                  false,
                                  false,
                                  _vm.job
                                )
                              }
                            },
                            model: {
                              value: _vm.job.ata,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "ata", $$v)
                              },
                              expression: "job.ata"
                            }
                          }),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("filterWeek")(_vm.job.ataSailingDay)
                              )
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.cargoCode && _vm.elementDict.cargoCode.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "cargoCode", "label-width": "120px" },
                      slot: "cargoCode"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.cargoCode.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.cargoCode.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        class: _vm.importDifferenceField.cargoCode
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "48",
                          "select-type":
                            _vm.selectTypeNames.basic_data_CargoInformation,
                          filterable: "",
                          "callback-params": { key: "cargoCode" },
                          "default-value": _vm.job.cargoCode,
                          placeholder: " ",
                          disabled: !_vm.elementDict.cargoCode.writable
                        },
                        on: {
                          parentCallBack: _vm.txtCargoInformationChangeHandler
                        }
                      }),
                      _c("el-input", {
                        class: _vm.importDifferenceField.cargoName
                          ? "red-border"
                          : "",
                        attrs: {
                          disabled:
                            !_vm.job.cargoCode ||
                            !_vm.elementDict.cargoCode.writable
                        },
                        model: {
                          value: _vm.job.cargoName,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "cargoName", $$v)
                          },
                          expression: "job.cargoName"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.transportSource &&
              _vm.elementDict.transportSource.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        slot: "transportSource",
                        "label-width": "120px"
                      },
                      slot: "transportSource"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.transportSource.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.transportSource.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          filterable: "",
                          "select-type":
                            _vm.selectTypeNames.basic_data_TransportSource,
                          no: "transportSource",
                          "default-value": _vm.job.transportSource,
                          cache: false,
                          "tag-value": "code",
                          placeholder: " ",
                          disabled: !_vm.elementDict.transportSource.writable
                        },
                        on: {
                          parentCallBack: function(item) {
                            return (_vm.job.transportSource = item.value)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.statisticArea &&
              _vm.elementDict.statisticArea.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "statisticArea", "label-width": "120px" },
                      slot: "statisticArea"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.statisticArea.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.statisticArea.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          filterable: "",
                          "select-type":
                            _vm.selectTypeNames.basic_data_StatisticArea,
                          no: "statisticArea",
                          "default-value": _vm.job.statisticArea,
                          cache: false,
                          "tag-value": "code",
                          placeholder: " ",
                          disabled: !_vm.elementDict.statisticArea.writable
                        },
                        on: {
                          parentCallBack: function(item) {
                            return (_vm.job.statisticArea = item.value)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isFba
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.Package"),
                        "label-width": "120px"
                      }
                    },
                    [
                      _c("cargo-packing-select", {
                        attrs: {
                          no: "packing",
                          "default-value": _vm.job.packing,
                          "callback-params": {},
                          placeholder: " "
                        },
                        on: {
                          change: function(p) {
                            p.key = "packing"
                            _vm.setJobSelectValue(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isFba
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.HsCode"),
                        "label-width": "120px"
                      }
                    },
                    [
                      _c("el-input", {
                        class: _vm.importDifferenceField.hsCode
                          ? "red-border"
                          : "",
                        attrs: {
                          disabled: !_vm.elementDict.hsCode.writable,
                          no: "hsCode"
                        },
                        model: {
                          value: _vm.job.hsCode,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "hsCode", $$v)
                          },
                          expression: "job.hsCode"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isFba
                ? _c("el-form-item", { attrs: { "label-width": "0" } }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-around"
                        }
                      },
                      [
                        _c(
                          "el-checkbox",
                          {
                            staticStyle: {
                              "margin-right": "10px",
                              "margin-left": "20px"
                            },
                            attrs: { no: "125" },
                            model: {
                              value: _vm.fbaJob.electric,
                              callback: function($$v) {
                                _vm.$set(_vm.fbaJob, "electric", $$v)
                              },
                              expression: "fbaJob.electric"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("AirExport.WithBattery")))]
                        ),
                        _c(
                          "el-checkbox",
                          {
                            staticStyle: { "margin-right": "10px" },
                            attrs: { no: "126" },
                            model: {
                              value: _vm.fbaJob.magnetic,
                              callback: function($$v) {
                                _vm.$set(_vm.fbaJob, "magnetic", $$v)
                              },
                              expression: "fbaJob.magnetic"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("AirExport.WithMagnet")))]
                        ),
                        _c(
                          "el-checkbox",
                          {
                            staticStyle: { "margin-right": "10px" },
                            attrs: { no: "127" },
                            model: {
                              value: _vm.fbaJob.powdery,
                              callback: function($$v) {
                                _vm.$set(_vm.fbaJob, "powdery", $$v)
                              },
                              expression: "fbaJob.powdery"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("AirExport.Powder")))]
                        ),
                        _c(
                          "el-checkbox",
                          {
                            staticStyle: { "margin-right": "10px" },
                            attrs: { no: "128" },
                            model: {
                              value: _vm.fbaJob.liquid,
                              callback: function($$v) {
                                _vm.$set(_vm.fbaJob, "liquid", $$v)
                              },
                              expression: "fbaJob.liquid"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("AirExport.Liquid")))]
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm.elementDict.airUlds &&
              _vm.elementDict.airUlds.viewable &&
              !_vm.job.lclMasterUuid &&
              _vm.job.operateType !== 0
                ? _c("booking-air-uld-data-grid", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      slot: "airUlds",
                      value: _vm.airUlds,
                      "is-edit":
                        _vm.isEdit || !_vm.elementDict.airUlds.writable,
                      job: _vm.job
                    },
                    slot: "airUlds"
                  })
                : _vm._e(),
              _vm.elementDict.warehouseNo &&
              _vm.elementDict.warehouseNo.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "warehouseNo" }, slot: "warehouseNo" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.warehouseNo.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.warehouseNo.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled: !_vm.elementDict.warehouseNo.writable,
                          no: "52",
                          type: "textarea",
                          rows: 5
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            return _vm.showWarehouseDialog($event)
                          }
                        },
                        model: {
                          value: _vm.job.warehouseNo,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "warehouseNo", $$v)
                          },
                          expression: "job.warehouseNo"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.frontEndWarehouseOperation &&
              _vm.elementDict.frontEndWarehouseOperation.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "frontEndWarehouseOperation" },
                      slot: "frontEndWarehouseOperation"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.frontEndWarehouseOperation
                          .isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label:
                            _vm.elementDict.frontEndWarehouseOperation &&
                            _vm.elementDict.frontEndWarehouseOperation.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "frontEndWarehouseOperation",
                          "select-type":
                            _vm.selectTypeNames.basic_data_AirportCargoTerminal,
                          "method-params": {
                            dataType: 1,
                            deletionFlag: false,
                            orderType: _vm.SystemConstants.AE.code
                          },
                          filterable: "",
                          clearable: true,
                          "default-value": _vm.job.frontEndWarehouseOperation,
                          disabled: !_vm.elementDict.frontEndWarehouseOperation
                            .writable
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.frontEndWarehouseOperation = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.agentInformation &&
              _vm.elementDict.agentInformation.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "agentInformation" },
                      slot: "agentInformation"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.agentInformation.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.agentInformation.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-textarea", {
                        attrs: {
                          no: "agentInformation",
                          type: "textarea",
                          row: 3,
                          disabled: !_vm.elementDict.agentInformation.writable
                        },
                        model: {
                          value: _vm.job.agentInformation,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "agentInformation", $$v)
                          },
                          expression: "job.agentInformation"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.warehouseStatus &&
              _vm.elementDict.warehouseStatus.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "warehouseStatus", no: "WarehouseState" },
                      slot: "warehouseStatus"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.warehouseStatus.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.warehouseStatus.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "el-select",
                        {
                          attrs: {
                            disabled:
                              true || !_vm.elementDict.warehouseStatus.writable,
                            placeholder: _vm.$t("Message.PleaseSelect"),
                            size: "mini",
                            no: "130"
                          },
                          model: {
                            value: _vm.job.warehouseStatus,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "warehouseStatus", $$v)
                            },
                            expression: "job.warehouseStatus"
                          }
                        },
                        _vm._l(_vm.WarehouseInState.WAREHOUSE_STATE, function(
                          item,
                          index
                        ) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label:
                                _vm.$store.getters.language === "zh"
                                  ? item.chineseName
                                  : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.estimatedDateOfWarehousinge &&
              _vm.elementDict.estimatedDateOfWarehousinge.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "estimatedDateOfWarehousinge" },
                      slot: "estimatedDateOfWarehousinge"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.estimatedDateOfWarehousinge
                          .isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label:
                            _vm.elementDict.estimatedDateOfWarehousinge.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        ref: "estimatedDateOfWarehousinge",
                        class: _vm.importDifferenceField
                          .estimatedDateOfWarehousinge
                          ? "red-border"
                          : "",
                        staticStyle: { width: "100%" },
                        attrs: {
                          disabled: !_vm.elementDict.estimatedDateOfWarehousinge
                            .writable,
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm:ss",
                          clearable: "",
                          no: "131"
                        },
                        on: {
                          change: _vm.changeEstimatedDateOfWarehousinge,
                          blur: function() {
                            _vm.handleBlur(
                              "estimatedDateOfWarehousinge",
                              _vm.changeEstimatedDateOfWarehousinge,
                              true,
                              true,
                              _vm.job
                            )
                          }
                        },
                        model: {
                          value: _vm.job.estimatedDateOfWarehousinge,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.job,
                              "estimatedDateOfWarehousinge",
                              $$v
                            )
                          },
                          expression: "job.estimatedDateOfWarehousinge"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.warehouseInDate &&
              _vm.elementDict.warehouseInDate.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "warehouseInDate" },
                      slot: "warehouseInDate"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.warehouseInDate.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.warehouseInDate.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "datetime",
                          disabled: true,
                          placeholder: _vm.$t(
                            "CargoMsg.Cargo_SyncWarehouseData"
                          ),
                          value: _vm.job.warehouseInDate,
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm:ss",
                          clearable: "",
                          no: "132"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.estimatedDeliveryTime &&
              _vm.elementDict.estimatedDeliveryTime.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "estimatedDeliveryTime" },
                      slot: "estimatedDeliveryTime"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.estimatedDeliveryTime.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.estimatedDeliveryTime.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        ref: "estimatedDeliveryTime",
                        class: _vm.importDifferenceField.estimatedDeliveryTime
                          ? "red-border"
                          : "",
                        staticStyle: { width: "100%" },
                        attrs: {
                          disabled: !_vm.elementDict.estimatedDeliveryTime
                            .writable,
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm:ss",
                          clearable: "",
                          no: "133"
                        },
                        on: {
                          change: _vm.changeEstimatedDeliveryTime,
                          blur: function() {
                            _vm.handleBlur(
                              "estimatedDeliveryTime",
                              _vm.changeEstimatedDeliveryTime,
                              true,
                              true,
                              _vm.job
                            )
                          }
                        },
                        model: {
                          value: _vm.job.estimatedDeliveryTime,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "estimatedDeliveryTime", $$v)
                          },
                          expression: "job.estimatedDeliveryTime"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.warehouseOutDate &&
              _vm.elementDict.warehouseOutDate.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "warehouseOutDate" },
                      slot: "warehouseOutDate"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.warehouseOutDate.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.warehouseOutDate.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        ref: "warehouseOutDate",
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "datetime",
                          disabled: true,
                          placeholder: _vm.$t(
                            "CargoMsg.Cargo_SyncWarehouseData"
                          ),
                          value: _vm.job.warehouseOutDate,
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm:ss",
                          clearable: "",
                          no: "134"
                        },
                        on: {
                          blur: function() {
                            _vm.handleBlur(
                              "warehouseOutDate",
                              null,
                              true,
                              true,
                              _vm.job
                            )
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.cargoTerminalOperation &&
              _vm.elementDict.cargoTerminalOperation.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "cargoTerminalOperation" },
                      slot: "cargoTerminalOperation"
                    },
                    [
                      _c("line-label", {
                        class:
                          _vm.elementDict.cargoTerminalOperation &&
                          _vm.elementDict.cargoTerminalOperation.isRequire
                            ? "blue"
                            : "",
                        attrs: {
                          slot: "label",
                          label:
                            _vm.elementDict.cargoTerminalOperation &&
                            _vm.elementDict.cargoTerminalOperation.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "cargoTerminalOperation",
                          "select-type":
                            _vm.selectTypeNames.basic_data_AirportCargoTerminal,
                          "method-params": { dataType: 0, deletionFlag: false },
                          filterable: "",
                          clearable: true,
                          "default-value": _vm.job.cargoTerminalOperation,
                          disabled: !_vm.elementDict.cargoTerminalOperation
                            .writable
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.cargoTerminalOperation = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.estimatedDeliveryDate &&
              _vm.elementDict.estimatedDeliveryDate.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "estimatedDeliveryDate" },
                      slot: "estimatedDeliveryDate"
                    },
                    [
                      _c("line-label", {
                        class:
                          _vm.elementDict.estimatedDeliveryDate &&
                          _vm.elementDict.estimatedDeliveryDate.isRequire
                            ? "blue"
                            : "",
                        attrs: {
                          slot: "label",
                          label:
                            _vm.elementDict.estimatedDeliveryDate &&
                            _vm.elementDict.estimatedDeliveryDate.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          disabled:
                            !_vm.isEdit ||
                            !_vm.job.cargoTerminalOperation ||
                            !_vm.elementDict.estimatedDeliveryDate.writable,
                          no: "estimatedDeliveryDate",
                          type: "date",
                          "value-format": "yyyy-MM-dd",
                          clearable: ""
                        },
                        model: {
                          value: _vm.job.estimatedDeliveryDate,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "estimatedDeliveryDate", $$v)
                          },
                          expression: "job.estimatedDeliveryDate"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.customerRefNo &&
              _vm.elementDict.customerRefNo.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "customerRefNo" }, slot: "customerRefNo" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.customerRefNo.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.customerRefNo.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-input", {
                        attrs: {
                          disabled: !_vm.elementDict.customerRefNo.writable,
                          no: "53",
                          trim: true
                        },
                        model: {
                          value: _vm.job.customerRefNo,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "customerRefNo", $$v)
                          },
                          expression: "job.customerRefNo"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.relatedJob2 &&
              _vm.elementDict.relatedJob2.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "relatedJob2" }, slot: "relatedJob2" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.relatedJob2.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.relatedJob2.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled: !_vm.elementDict.relatedJob2.writable,
                          no: "54"
                        },
                        model: {
                          value: _vm.job.relatedJob2,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "relatedJob2", $$v)
                          },
                          expression: "job.relatedJob2"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.kcNo && _vm.elementDict.kcNo.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "kcNo" }, slot: "kcNo" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.kcNo.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.kcNo.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled: !_vm.elementDict.kcNo.writable,
                          no: "55"
                        },
                        model: {
                          value: _vm.job.kcNo,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "kcNo", $$v)
                          },
                          expression: "job.kcNo"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.poNo && _vm.elementDict.poNo.viewable
                ? _c(
                    "el-form-item",
                    {
                      class: _vm.poNoRed ? "poNoClass" : "",
                      attrs: { slot: "poNo" },
                      slot: "poNo"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.poNo.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.poNo.label
                        },
                        slot: "label"
                      }),
                      !_vm.openProjectConfig
                        ? _c("el-input", {
                            attrs: {
                              disabled: !_vm.elementDict.poNo.writable,
                              no: "56"
                            },
                            model: {
                              value: _vm.job.poNo,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "poNo", $$v)
                              },
                              expression: "job.poNo"
                            }
                          })
                        : _vm._e(),
                      _vm.openProjectConfig
                        ? _c("cargo-project-select", {
                            attrs: {
                              no: "57",
                              "default-value": _vm.job.poNo,
                              "customer-id": _vm.job.customerId,
                              "is-linked": _vm.isProjectLinkedCustomer,
                              placeholder: " "
                            },
                            on: {
                              change: function(p) {
                                _vm.job.poNo = p.value
                                _vm.job.projectName = p.projectName
                                _vm.changeProject()
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.projectName &&
              _vm.elementDict.projectName.viewable &&
              _vm.openProjectConfig
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "projectName" }, slot: "projectName" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.projectName.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.projectName.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: { no: "58", disabled: true },
                        model: {
                          value: _vm.job.projectName,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "projectName", $$v)
                          },
                          expression: "job.projectName"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.projectBatch &&
              _vm.elementDict.projectBatch.viewable &&
              _vm.openProjectConfig
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "projectBatch" }, slot: "projectBatch" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.projectBatch.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.projectBatch.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled: !_vm.elementDict.projectBatch.writable,
                          no: "59"
                        },
                        model: {
                          value: _vm.job.projectBatch,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "projectBatch", $$v)
                          },
                          expression: "job.projectBatch"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.paymentTermMBL &&
              _vm.elementDict.paymentTermMBL.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "paymentTermMBL" },
                      slot: "paymentTermMBL"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.paymentTermMBL.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.paymentTermMBL.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        class: _vm.importDifferenceField.paymentTermMBL
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "60",
                          "select-type":
                            _vm.selectTypeNames.basic_data_PaymentTerm,
                          filterable: "",
                          clearable: false,
                          "default-value": _vm.job.paymentTermMBL,
                          disabled: !_vm.elementDict.paymentTermMBL.writable
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.paymentTermMBLChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.paymentTermHBL &&
              _vm.elementDict.paymentTermHBL.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "paymentTermHBL" },
                      slot: "paymentTermHBL"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.paymentTermHBL.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.paymentTermHBL.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        class: _vm.importDifferenceField.paymentTermHBL
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "61",
                          filterable: "",
                          clearable: false,
                          "select-type":
                            _vm.selectTypeNames.basic_data_PaymentTerm,
                          "default-value": _vm.job.paymentTermHBL,
                          placeholder: " ",
                          disabled: !_vm.elementDict.paymentTermHBL.writable
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.paymentTermHBLChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.cabinReq && _vm.elementDict.cabinReq.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "cabinReq" }, slot: "cabinReq" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.cabinReq.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.cabinReq.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled: !_vm.elementDict.cabinReq.writable,
                          no: "62"
                        },
                        model: {
                          value: _vm.job.cabinReq,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "cabinReq", $$v)
                          },
                          expression: "job.cabinReq"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.loadReq && _vm.elementDict.loadReq.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "loadReq" }, slot: "loadReq" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.loadReq.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.loadReq.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled: !_vm.elementDict.loadReq.writable,
                          no: "63"
                        },
                        model: {
                          value: _vm.job.loadReq,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "loadReq", $$v)
                          },
                          expression: "job.loadReq"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.docReq && _vm.elementDict.docReq.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "docReq" }, slot: "docReq" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.docReq.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.docReq.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled: !_vm.elementDict.docReq.writable,
                          no: "64"
                        },
                        model: {
                          value: _vm.job.docReq,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "docReq", $$v)
                          },
                          expression: "job.docReq"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.cargoType && _vm.elementDict.cargoType.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "cargoType" }, slot: "cargoType" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.cargoType.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.cargoType.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "el-select",
                        {
                          class: _vm.importDifferenceField.cargoType
                            ? "red-border"
                            : "",
                          attrs: {
                            disabled: !_vm.elementDict.cargoType.writable,
                            filterable: "",
                            no: "135"
                          },
                          on: { change: _vm.onCargoTypeChagne },
                          model: {
                            value: _vm.job.cargoType,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "cargoType", $$v)
                            },
                            expression: "job.cargoType"
                          }
                        },
                        _vm._l(_vm.cargoType4JobSelect, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.isZh
                                ? item.chineseName
                                : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.salesChannel &&
              _vm.elementDict.salesChannel.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "salesChannel" }, slot: "salesChannel" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.salesChannel.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.salesChannel.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: { disabled: true, no: "136" },
                        model: {
                          value: _vm.job.salesChannel,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "salesChannel", $$v)
                          },
                          expression: "job.salesChannel"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.trustFromJob &&
              _vm.elementDict.trustFromJob.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "trustFromJob" }, slot: "trustFromJob" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.trustFromJob.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.trustFromJob.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: { disabled: true, no: "trustFromJob" },
                        model: {
                          value: _vm.job.trustFromJob,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "trustFromJob", $$v)
                          },
                          expression: "job.trustFromJob"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.relatedJob && _vm.elementDict.relatedJob.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "relatedJob" }, slot: "relatedJob" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.relatedJob.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.relatedJob.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: { disabled: true, no: "relatedJob" },
                        model: {
                          value: _vm.job.relatedJob,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "relatedJob", $$v)
                          },
                          expression: "job.relatedJob"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.channelNo &&
              _vm.elementDict.channelNo.viewable &&
              _vm.showChannelNo
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "channelNo" }, slot: "channelNo" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.channelNo.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.channelNo.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: { disabled: true, no: "137" },
                        model: {
                          value: _vm.job.channelNo,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "channelNo", $$v)
                          },
                          expression: "job.channelNo"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.measurements &&
              _vm.elementDict.measurements.viewable
                ? _c(
                    "template",
                    { slot: "measurements" },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("line-label", {
                            class: _vm.elementDict.measurements.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.measurements.label
                            },
                            slot: "label"
                          }),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                no: "GetGoodsInformation",
                                disabled:
                                  !_vm.isEdit ||
                                  !_vm.elementDict.measurements.writable,
                                type: "primary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.pm.getCargoInformation()
                                }
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("SeaExport.GetGoodsInformation")
                                  ) +
                                  " "
                              )
                            ]
                          ),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "light",
                                content: _vm.$t(
                                  "SeaExport.GetGoodsInformationTip"
                                ),
                                placement: "right-end",
                                disabled: ""
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-question",
                                staticStyle: {
                                  cursor: "pointer",
                                  "margin-left": "4px",
                                  color: "#1989fa"
                                }
                              })
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { staticClass: "auto-width", attrs: { label: "" } },
                        [
                          _c("el-input", {
                            attrs: {
                              no: "66",
                              type: "textarea",
                              disabled: !_vm.elementDict.measurements.writable,
                              rows: 3
                            },
                            on: {
                              change: function(p) {
                                _vm.pm.measurementsChangeHandler(p)
                              }
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.elementDict.measurements.label,
                                  _vm.job.measurements,
                                  function(val) {
                                    _vm.pm.doMeasurementsChangeHandler(val)
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.job.measurements,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "measurements", $$v)
                              },
                              expression: "job.measurements"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.selling && _vm.elementDict.selling.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "selling" }, slot: "selling" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.selling.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.selling.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c("el-input", {
                            staticStyle: {
                              width: "120px",
                              "margin-right": "5px"
                            },
                            attrs: {
                              disabled:
                                _vm.job.sellingPriceLock ||
                                !_vm.isEdit ||
                                !_vm.elementDict.selling.writable,
                              no: "67"
                            },
                            on: {
                              change: function($event) {
                                return _vm.sellingOrBuyingChangeHandler(true, 3)
                              }
                            },
                            model: {
                              value: _vm.job.selling,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "selling", $$v)
                              },
                              expression: "job.selling"
                            }
                          }),
                          _c("cargo-advance-select", {
                            staticStyle: { flex: "1" },
                            attrs: {
                              filterable: "",
                              no: "sellingCurrency",
                              placeholder: " ",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Currency,
                              disabled:
                                _vm.job.sellingPriceLock ||
                                !_vm.isEdit ||
                                !_vm.elementDict.selling.writable,
                              "default-value": _vm.job.sellingCurrency,
                              clearable: false
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.job.sellingCurrency = p.code
                                _vm.sellingOrBuyingChangeHandler(false, 1)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.buying && _vm.elementDict.buying.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "buying" }, slot: "buying" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.buying.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.buying.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c("el-input", {
                            staticStyle: {
                              width: "120px",
                              "margin-right": "5px"
                            },
                            attrs: {
                              disabled:
                                _vm.job.purchasePriceLock ||
                                !_vm.isEdit ||
                                !_vm.elementDict.buying.writable,
                              no: "68"
                            },
                            on: {
                              change: function($event) {
                                return _vm.sellingOrBuyingChangeHandler(true, 3)
                              }
                            },
                            model: {
                              value: _vm.job.buying,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "buying", $$v)
                              },
                              expression: "job.buying"
                            }
                          }),
                          _c("cargo-advance-select", {
                            staticStyle: { flex: "1" },
                            attrs: {
                              filterable: "",
                              no: "buyingCurrency",
                              placeholder: " ",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Currency,
                              disabled:
                                _vm.job.purchasePriceLock ||
                                !_vm.isEdit ||
                                !_vm.elementDict.buying.writable,
                              "default-value": _vm.job.buyingCurrency,
                              clearable: false
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.job.buyingCurrency = p.code
                                _vm.sellingOrBuyingChangeHandler(false, 1)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.sellPriceType &&
              _vm.elementDict.sellPriceType.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        slot: "sellPriceType",
                        label: _vm.elementDict.sellPriceType.label
                      },
                      slot: "sellPriceType"
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            disabled:
                              _vm.job.purchasePriceLock ||
                              !_vm.isEdit ||
                              !_vm.elementDict.sellPriceType.writable,
                            placeholder: _vm.$t("Message.PleaseSelect"),
                            size: "mini",
                            no: "sellPriceType"
                          },
                          on: {
                            change: function($event) {
                              return _vm.sellingOrBuyingChangeHandler(false, 2)
                            }
                          },
                          model: {
                            value: _vm.job.sellPriceType,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "sellPriceType", $$v)
                            },
                            expression: "job.sellPriceType"
                          }
                        },
                        _vm._l(_vm.AirExportConstants.SELL_BUY_PRICE, function(
                          item,
                          index
                        ) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label:
                                _vm.$store.getters.language === "zh"
                                  ? item.chineseName
                                  : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.buyPriceType &&
              _vm.elementDict.buyPriceType.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        slot: "buyPriceType",
                        label: _vm.elementDict.buyPriceType.label
                      },
                      slot: "buyPriceType"
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            disabled:
                              _vm.job.purchasePriceLock ||
                              !_vm.isEdit ||
                              !_vm.elementDict.buyPriceType.writable,
                            placeholder: _vm.$t("Message.PleaseSelect"),
                            size: "mini",
                            no: "buyPriceType"
                          },
                          on: {
                            change: function($event) {
                              return _vm.sellingOrBuyingChangeHandler(false, 2)
                            }
                          },
                          model: {
                            value: _vm.job.buyPriceType,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "buyPriceType", $$v)
                            },
                            expression: "job.buyPriceType"
                          }
                        },
                        _vm._l(_vm.AirExportConstants.SELL_BUY_PRICE, function(
                          item,
                          index
                        ) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label:
                                _vm.$store.getters.language === "zh"
                                  ? item.chineseName
                                  : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.protocolType &&
              _vm.elementDict.protocolType.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "protocolType" }, slot: "protocolType" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.protocolType.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.protocolType.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "69",
                          filterable: "",
                          clearable: false,
                          "select-type":
                            _vm.selectTypeNames
                              .local_cache_SystemConstants$PROTOCOL_TYPES,
                          "callback-method-type": "value",
                          "default-value": _vm.job.protocolType || "none",
                          "tag-name": _vm.isZh ? "chineseName" : "englishName",
                          fields: ["chineseName"],
                          "callback-params": { key: "protocolType" },
                          disabled: !_vm.elementDict.protocolType.writable
                        },
                        on: { parentCallBack: _vm.setJobSelectValue }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.operationContent &&
              _vm.elementDict.operationContent.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "operationContent" },
                      slot: "operationContent"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.operationContent.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.operationContent.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: _vm.job.operationContent,
                            placement: "left"
                          }
                        },
                        [
                          _c("div", {
                            attrs: { slot: "content" },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.job.operationContent
                                  ? _vm.job.operationContent.replace(
                                      /[\n]/g,
                                      "</br>"
                                    )
                                  : _vm.$t("SeaExport.NoData")
                              )
                            },
                            slot: "content"
                          }),
                          _c("el-input", {
                            attrs: {
                              no: "70",
                              disabled: !_vm.elementDict.operationContent
                                .writable,
                              value: _vm.job.operationContent,
                              placeholder: _vm.viewStatus
                                ? ""
                                : _vm.$t(
                                    "SeaExport.DoubleClickToAddOperationRequirements"
                                  ),
                              type: "textarea",
                              rows: 4
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.selectOperationReqDialog.value =
                                  _vm.job.operationContent
                                _vm.selectOperationReqDialog.visible = !_vm.viewStatus
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.temperatureRequirement &&
              _vm.elementDict.temperatureRequirement.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "temperatureRequirement" },
                      slot: "temperatureRequirement"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.temperatureRequirement.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.temperatureRequirement.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "temperatureRequirement",
                          disabled: !_vm.elementDict.temperatureRequirement
                            .writable,
                          cache: false,
                          filterable: "",
                          "allow-create": "",
                          "tag-name": "code",
                          "tag-value": "code",
                          "static-options": _vm.temperatureRequirementDownList,
                          "default-value": _vm.job.temperatureRequirement
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.temperatureRequirement = p.code
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.wood && _vm.elementDict.wood.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "wood" }, slot: "wood" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.wood.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.wood.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "147",
                              clearable: false,
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames
                                  .local_cache_AirExportConstants$WOOD,
                              "default-value": _vm.job.wood,
                              fields: ["chineseName"],
                              disabled: !_vm.elementDict.wood.writable
                            },
                            on: { parentCallBack: _vm.onWoodOrNotWoodChagne }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.hazardousGoodsOption &&
              _vm.elementDict.hazardousGoodsOption.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "wood" }, slot: "wood" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.hazardousGoodsOption.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.hazardousGoodsOption.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "148",
                              clearable: false,
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames
                                  .local_cache_AirExportConstants$HAZARDOUS_GOODS_OPTION,
                              "default-value": _vm.job.hazardousGoodsOption,
                              fields: ["chineseName"],
                              disabled: !_vm.elementDict.hazardousGoodsOption
                                .writable
                            },
                            on: {
                              parentCallBack: _vm.onHazardousGoodsOptionChagne
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.handlingInformation &&
              _vm.elementDict.handlingInformation.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "wood" }, slot: "wood" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.handlingInformation.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.handlingInformation.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          no: "149",
                          readonly: true,
                          type: "textarea",
                          rows: 5
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.handlingInformation"),
                              _vm.job.handlingInformation,
                              function(val) {
                                _vm.job.handlingInformation = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.job.handlingInformation,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "handlingInformation", $$v)
                          },
                          expression: "job.handlingInformation"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isFba
                ? _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.OperationTips") } },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "operationTips",
                          type: "textarea",
                          rows: 5
                        },
                        model: {
                          value: _vm.job.operationTips,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "operationTips", $$v)
                          },
                          expression: "job.operationTips"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.txtSalesOffice &&
              _vm.elementDict.txtSalesOffice.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "txtSalesOffice" },
                      slot: "txtSalesOffice"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.txtSalesOffice.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.txtSalesOffice.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        class: _vm.importDifferenceField.salesOffice
                          ? "red-border"
                          : "",
                        attrs: { no: "71", disabled: true },
                        model: {
                          value: _vm.txtSalesOffice,
                          callback: function($$v) {
                            _vm.txtSalesOffice = $$v
                          },
                          expression: "txtSalesOffice"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.elementDict.sales && _vm.elementDict.sales.viewable,
                      expression:
                        "elementDict.sales && elementDict.sales.viewable"
                    }
                  ],
                  attrs: { slot: "sales" },
                  slot: "sales"
                },
                [
                  _c("line-label", {
                    class:
                      _vm.elementDict.sales.isRequire ||
                      _vm.job.cargoSource !== "NC"
                        ? "blue"
                        : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.sales.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between"
                      }
                    },
                    [
                      _c("cargo-user-select", {
                        ref: "sales",
                        class: _vm.importDifferenceField.sales
                          ? "red-border"
                          : "",
                        staticStyle: { width: "130px", flex: "1" },
                        attrs: {
                          no: "72",
                          disabled:
                            !_vm.saleEnabled || !_vm.elementDict.sales.writable,
                          "method-params": {
                            officeId: _vm.salesOfficeCheck
                              ? _vm.$store.getters.currentOfficeId
                              : "",
                            category: "role",
                            shape: "sales",
                            active: true
                          },
                          "default-value": _vm.job.sales || "",
                          "static-options": _vm.salesList,
                          placeholder: _vm.salesPrompt || " "
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.salesChangeHandler(p)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "el-checkbox",
                        {
                          staticStyle: { "margin-left": "5px" },
                          attrs: { no: "73", disabled: true },
                          model: {
                            value: _vm.job.provisioned,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "provisioned", $$v)
                            },
                            expression: "job.provisioned"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Accrued")))]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.elementDict.cargoSalesId &&
              _vm.elementDict.cargoSalesId.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "cargoSalesId" }, slot: "cargoSalesId" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.cargoSalesId.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.cargoSalesId.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        class: _vm.importDifferenceField.cargoSalesId
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "74",
                          "method-params": {
                            category: "role",
                            shape: "salesOfGoods"
                          },
                          "default-value": _vm.job.cargoSalesId || "",
                          disabled: !_vm.elementDict.cargoSalesId.writable,
                          placeholder: " ",
                          "static-options": _vm.cargoSalesList
                        },
                        on: {
                          change: function(p) {
                            _vm.job.cargoSalesId = p.value
                            _vm.pm.cargoSalesChargeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.salesDepartment &&
              _vm.elementDict.salesDepartment.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "salesDepartment" },
                      slot: "salesDepartment"
                    },
                    [
                      _c("line-label", {
                        class:
                          _vm.elementDict.salesDepartment.isRequire ||
                          _vm.job.cargoSource !== "NC"
                            ? "blue"
                            : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.salesDepartment.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-department-new-select", {
                        class: _vm.importDifferenceField.salesDepartment
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "75",
                          disabled:
                            !_vm.job.sales ||
                            !_vm.elementDict.salesDepartment.writable,
                          enables: true,
                          "sales-id": Number(_vm.job.sales),
                          "office-id": Number(_vm.job.salesOffice),
                          "department-id": Number(_vm.job.salesDepartment)
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.departmentChargeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.opOffice && _vm.elementDict.opOffice.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "opOffice" }, slot: "opOffice" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.opOffice.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.opOffice.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-office-select", {
                        class: _vm.importDifferenceField.opOffice
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "76",
                          disabled:
                            _vm.viewStatus ||
                            _vm.opOfficeDisabled ||
                            !_vm.elementDict.opOffice.writable,
                          "office-id": Number(_vm.job.opOffice),
                          placeholder: " ",
                          "is-regional-commission": _vm.isRegionalCommission
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.opOfficeChargeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.opDepartment &&
              _vm.elementDict.opDepartment.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "opDepartment" }, slot: "opDepartment" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.opDepartment.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.opDepartment.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-department-select", {
                        class: _vm.importDifferenceField.opDepartment
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "77",
                          disabled:
                            !_vm.opDeptEnabled ||
                            !_vm.elementDict.opDepartment.writable,
                          enables: true,
                          "office-id": Number(_vm.job.opOffice),
                          "department-id": Number(_vm.job.opDepartment),
                          placeholder: " "
                        },
                        on: {
                          change: function(p) {
                            _vm.job.opDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.op && _vm.elementDict.op.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "op" }, slot: "op" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.op.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.op.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        class: _vm.importDifferenceField.op ? "red-border" : "",
                        attrs: {
                          no: "78",
                          "method-params": {
                            officeId: _vm.job.opOffice,
                            category: "role",
                            shape: "op"
                          },
                          "default-value": _vm.job.op || "",
                          disabled: !_vm.elementDict.op.writable,
                          "static-options": _vm.userPortRoleData.op,
                          placeholder: " "
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.opChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.csrOffice && _vm.elementDict.csrOffice.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "csrOffice" }, slot: "csrOffice" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.csrOffice.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.csrOffice.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-office-select", {
                        class: _vm.importDifferenceField.csrOffice
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "csrOffice",
                          disabled: true,
                          "office-id": Number(_vm.job.csrOffice)
                        },
                        on: {
                          change: function(p) {
                            _vm.job.csrOffice = p.value
                            _vm.job.csrDepartment = 0
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.csrDepartment &&
              _vm.elementDict.csrDepartment.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "csrDepartment" }, slot: "csrDepartment" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.csrDepartment.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.csrDepartment.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-department-select", {
                        class: _vm.importDifferenceField.csrDepartment
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "csrDepartment",
                          "office-id": Number(_vm.job.csrOffice),
                          enables: true,
                          "department-id": Number(_vm.job.csrDepartment)
                        },
                        on: {
                          change: function(p) {
                            _vm.job.csrDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.csr && _vm.elementDict.csr.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "csr" }, slot: "csr" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.csr.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.csr.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        class: _vm.importDifferenceField.csr
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "79",
                          "method-params": { category: "role", shape: "csr" },
                          "default-value": _vm.job.csr || "",
                          disabled: !_vm.elementDict.csr.writable,
                          placeholder: " ",
                          "static-options": _vm.userPortRoleData.csr
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.csrChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.dcOffice && _vm.elementDict.dcOffice.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "dcOffice" }, slot: "dcOffice" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.dcOffice.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.dcOffice.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-office-select", {
                        class: _vm.importDifferenceField.dcOffice
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "dcOffice",
                          disabled: true,
                          "office-id": Number(_vm.job.dcOffice)
                        },
                        on: {
                          change: function(p) {
                            _vm.job.dcOffice = p.value
                            _vm.job.dcDepartment = 0
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.dcDepartment &&
              _vm.elementDict.dcDepartment.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "dcDepartment" }, slot: "dcDepartment" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.dcDepartment.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.dcDepartment.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-department-select", {
                        class: _vm.importDifferenceField.dcDepartment
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "dcDepartment",
                          "office-id": Number(_vm.job.dcOffice),
                          enables: true,
                          "department-id": Number(_vm.job.dcDepartment)
                        },
                        on: {
                          change: function(p) {
                            _vm.job.dcDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.dc && _vm.elementDict.dc.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "dc" }, slot: "dc" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.dc.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.dc.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        class: _vm.importDifferenceField.dc ? "red-border" : "",
                        attrs: {
                          no: "80",
                          "method-params": { category: "role", shape: "doc" },
                          "default-value": _vm.job.dc || "",
                          disabled: !_vm.elementDict.dc.writable,
                          placeholder: " ",
                          "static-options": _vm.userPortRoleData.doc
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.dcChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.plannerOffice &&
              _vm.elementDict.plannerOffice.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "plannerOffice" }, slot: "plannerOffice" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.plannerOffice.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.plannerOffice.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-office-select", {
                        class: _vm.importDifferenceField.plannerOffice
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "plannerOffice",
                          disabled: true,
                          "office-id": Number(_vm.job.plannerOffice)
                        },
                        on: {
                          change: function(p) {
                            _vm.job.plannerOffice = p.value
                            _vm.job.plannerDepartment = 0
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.plannerDepartment &&
              _vm.elementDict.plannerDepartment.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "plannerDepartment" },
                      slot: "plannerDepartment"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.plannerDepartment.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.plannerDepartment.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-department-select", {
                        class: _vm.importDifferenceField.plannerDepartment
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "plannerDepartment",
                          "office-id": Number(_vm.job.plannerOffice),
                          enables: true,
                          "department-id": Number(_vm.job.plannerDepartment)
                        },
                        on: {
                          change: function(p) {
                            _vm.job.plannerDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.planner && _vm.elementDict.planner.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "planner" }, slot: "planner" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.planner.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.planner.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        class: _vm.importDifferenceField.planner
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "81",
                          "method-params": {
                            officeId: _vm.job.opOffice,
                            category: "role",
                            shape: "airline"
                          },
                          "default-value": _vm.job.planner || "",
                          placeholder: " ",
                          disabled: !_vm.elementDict.planner.writable,
                          "static-options": _vm.userPortRoleData.airline
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.plannerChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.siteOP && _vm.elementDict.siteOP.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "siteOP" }, slot: "siteOP" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.siteOP.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.siteOP.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        attrs: {
                          no: "82",
                          "method-params": {
                            officeId: _vm.job.opOffice,
                            category: "role",
                            shape: "siteOp"
                          },
                          "default-value": _vm.job.siteOP || "",
                          placeholder: " ",
                          disabled: !_vm.elementDict.siteOP.writable,
                          "static-options": _vm.userPortRoleData.siteOp
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.siteOpChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.elementDict.overseaOp &&
                        _vm.elementDict.overseaOp.viewable,
                      expression:
                        "elementDict.overseaOp && elementDict.overseaOp.viewable"
                    }
                  ],
                  attrs: { slot: "overseaOp" },
                  slot: "overseaOp"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.overseaOp.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.overseaOp.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "overseaOp",
                    attrs: {
                      no: "83",
                      disabled: !_vm.elementDict.overseaOp.writable,
                      "default-value": _vm.job.overseaOp || "",
                      "method-params": { category: "role", shape: "overseaOp" },
                      "static-options": _vm.isHC
                        ? null
                        : _vm.userPortRoleData.overseaOp ||
                          _vm.overseaAgentUsersList,
                      "merge-load": true,
                      placeholder: " "
                    },
                    on: {
                      change: function(p) {
                        _vm.job.overseaOp = p.value
                        _vm.pm.overseaOpChangeHandler(p)
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.elementDict.userDefinedRoleId1 &&
                        _vm.elementDict.userDefinedRoleId1.viewable &&
                        _vm.isAddUserDefinedRoles,
                      expression:
                        "elementDict.userDefinedRoleId1 && elementDict.userDefinedRoleId1.viewable && isAddUserDefinedRoles"
                    }
                  ],
                  attrs: { slot: "userDefinedRoleId1" },
                  slot: "userDefinedRoleId1"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedRoleId1.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedRoleId1.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "userDefinedRoleId1",
                    attrs: {
                      no: "userDefinedRoleId1",
                      disabled:
                        _vm.viewStatus ||
                        !_vm.elementDict.userDefinedRoleId1.writable,
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId,
                        category: "role",
                        shape: "userDefinedRole1"
                      },
                      "default-value": _vm.job.userDefinedRoleId1 || "",
                      "merge-load": true,
                      placeholder: " ",
                      "static-options": _vm.userPortRoleData.userDefinedRole1
                    },
                    on: {
                      change: function(p) {
                        _vm.pm.userDefinedRoleId1Handler(p)
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.elementDict.userDefinedRoleId2 &&
                        _vm.elementDict.userDefinedRoleId2.viewable &&
                        _vm.isAddUserDefinedRoles,
                      expression:
                        "elementDict.userDefinedRoleId2 && elementDict.userDefinedRoleId2.viewable && isAddUserDefinedRoles"
                    }
                  ],
                  attrs: { slot: "userDefinedRoleId2" },
                  slot: "userDefinedRoleId2"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedRoleId2.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedRoleId2.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "userDefinedRoleId2",
                    attrs: {
                      no: "userDefinedRoleId2",
                      disabled:
                        _vm.viewStatus ||
                        !_vm.elementDict.userDefinedRoleId2.writable,
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId,
                        category: "role",
                        shape: "userDefinedRole2"
                      },
                      "default-value": _vm.job.userDefinedRoleId2 || "",
                      "merge-load": true,
                      placeholder: " ",
                      "static-options": _vm.userPortRoleData.userDefinedRole2
                    },
                    on: {
                      change: function(p) {
                        _vm.pm.userDefinedRoleId2Handler(p)
                      }
                    }
                  })
                ],
                1
              ),
              _vm.elementDict.userDefinedRoleId3 &&
              _vm.elementDict.userDefinedRoleId3.viewable &&
              _vm.isAddUserDefinedRoles
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "userDefinedRoleId3" },
                      slot: "userDefinedRoleId3"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.userDefinedRoleId3.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.userDefinedRoleId3.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        ref: "userDefinedRoleId3",
                        attrs: {
                          no: "userDefinedRoleId3",
                          disabled:
                            _vm.viewStatus ||
                            !_vm.elementDict.userDefinedRoleId3.writable,
                          "method-params": {
                            officeId: _vm.$store.getters.currentOfficeId,
                            category: "role",
                            shape: "userDefinedRole3"
                          },
                          "default-value": _vm.job.userDefinedRoleId3 || "",
                          "merge-load": true,
                          "static-options":
                            _vm.userPortRoleData.userDefinedRole3
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.userDefinedRoleId3Handler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.userDefinedRoleId4 &&
              _vm.elementDict.userDefinedRoleId4.viewable &&
              _vm.isAddUserDefinedRoles
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "userDefinedRoleId4" },
                      slot: "userDefinedRoleId4"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.userDefinedRoleId4.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.userDefinedRoleId4.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        ref: "userDefinedRoleId4",
                        attrs: {
                          no: "userDefinedRoleId4",
                          disabled:
                            _vm.viewStatus ||
                            !_vm.elementDict.userDefinedRoleId4.writable,
                          "method-params": {
                            officeId: _vm.$store.getters.currentOfficeId,
                            category: "role",
                            shape: "userDefinedRole4"
                          },
                          "default-value": _vm.job.userDefinedRoleId4 || "",
                          "merge-load": true,
                          "static-options":
                            _vm.userPortRoleData.userDefinedRole4
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.userDefinedRoleId4Handler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.userDefinedRoleId5 &&
              _vm.elementDict.userDefinedRoleId5.viewable &&
              _vm.isAddUserDefinedRoles
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "userDefinedRoleId5" },
                      slot: "userDefinedRoleId5"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.userDefinedRoleId5.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.userDefinedRoleId5.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        ref: "userDefinedRoleId5",
                        attrs: {
                          no: "userDefinedRoleId5",
                          disabled:
                            _vm.viewStatus ||
                            !_vm.elementDict.userDefinedRoleId5.writable,
                          "method-params": {
                            officeId: _vm.$store.getters.currentOfficeId,
                            category: "role",
                            shape: "userDefinedRole5"
                          },
                          "default-value": _vm.job.userDefinedRoleId5 || "",
                          "merge-load": true
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.userDefinedRoleId5Handler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.userDefinedRoleId6 &&
              _vm.elementDict.userDefinedRoleId6.viewable &&
              _vm.isAddUserDefinedRoles
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "userDefinedRoleId6" },
                      slot: "userDefinedRoleId6"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.userDefinedRoleId6.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.userDefinedRoleId6.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        ref: "userDefinedRoleId6",
                        attrs: {
                          no: "userDefinedRoleId6",
                          disabled:
                            _vm.viewStatus ||
                            !_vm.elementDict.userDefinedRoleId6.writable,
                          "method-params": {
                            officeId: _vm.$store.getters.currentOfficeId,
                            category: "role",
                            shape: "userDefinedRole6"
                          },
                          "default-value": _vm.job.userDefinedRoleId6 || "",
                          "merge-load": true
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.userDefinedRoleId6Handler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.userDefinedRoleId7 &&
              _vm.elementDict.userDefinedRoleId7.viewable &&
              _vm.isAddUserDefinedRoles
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "userDefinedRoleId7" },
                      slot: "userDefinedRoleId7"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.userDefinedRoleId7.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.userDefinedRoleId7.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        ref: "userDefinedRoleId7",
                        attrs: {
                          no: "userDefinedRoleId7",
                          disabled:
                            _vm.viewStatus ||
                            !_vm.elementDict.userDefinedRoleId7.writable,
                          "method-params": {
                            officeId: _vm.$store.getters.currentOfficeId,
                            category: "role",
                            shape: "userDefinedRole7"
                          },
                          "default-value": _vm.job.userDefinedRoleId7 || "",
                          "merge-load": true
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.userDefinedRoleId7Handler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.userDefinedRoleId8 &&
              _vm.elementDict.userDefinedRoleId8.viewable &&
              _vm.isAddUserDefinedRoles
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "userDefinedRoleId8" },
                      slot: "userDefinedRoleId8"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.userDefinedRoleId8.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.userDefinedRoleId8.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        ref: "userDefinedRoleId8",
                        attrs: {
                          no: "userDefinedRoleId8",
                          "method-params": {
                            officeId: _vm.$store.getters.currentOfficeId,
                            category: "role",
                            shape: "userDefinedRole8"
                          },
                          "default-multiple-value": _vm.toNumArray(
                            _vm.job.userDefinedRoleId8
                          ),
                          disabled:
                            _vm.viewStatus ||
                            !_vm.elementDict.userDefinedRoleId8.writable,
                          multiple: true,
                          "merge-load": true,
                          placeholder: _vm.viewStatus ? " " : ""
                        },
                        on: {
                          change: function(p) {
                            _vm.job.userDefinedRoleId8 = _vm.toTxt(p.value)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.elementDict.satisfiedRequests &&
                        _vm.elementDict.satisfiedRequests.viewable,
                      expression:
                        "elementDict.satisfiedRequests && elementDict.satisfiedRequests.viewable"
                    }
                  ],
                  attrs: { slot: "satisfiedRequests" },
                  slot: "satisfiedRequests"
                },
                [
                  _c("special-requests-grid", {
                    attrs: {
                      no: "satisfiedRequests",
                      "customer-id": _vm.job.customerId,
                      lob: _vm.job.lob,
                      job: _vm.job,
                      "is-edit":
                        !_vm.viewStatus ||
                        !_vm.elementDict.satisfiedRequests.writable
                    },
                    model: {
                      value: _vm.job.satisfiedRequests,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "satisfiedRequests", $$v)
                      },
                      expression: "job.satisfiedRequests"
                    }
                  })
                ],
                1
              ),
              _vm.elementDict.hsCode &&
              _vm.elementDict.hsCode.viewable &&
              !_vm.isFba
                ? _c(
                    "el-form-item",
                    {
                      staticStyle: { "margin-top": "10px" },
                      attrs: { slot: "hsCode" },
                      slot: "hsCode"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.hsCode.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.hsCode.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        class: _vm.importDifferenceField.hsCode
                          ? "red-border"
                          : "",
                        attrs: {
                          disabled: !_vm.elementDict.hsCode.writable,
                          no: "84"
                        },
                        model: {
                          value: _vm.job.hsCode,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "hsCode", $$v)
                          },
                          expression: "job.hsCode"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.remarks && _vm.elementDict.remarks.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "remarks" }, slot: "remarks" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.remarks.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.remarks.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled: !_vm.elementDict.remarks.writable,
                          no: "85",
                          type: "textarea",
                          rows: 5
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            return _vm.showAdvanceTextDialog(
                              _vm.elementDict.remarks.label,
                              _vm.job.remarks,
                              function(val) {
                                _vm.job.remarks = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.job.remarks,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "remarks", $$v)
                          },
                          expression: "job.remarks"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isFba
                ? _c(
                    "div",
                    { staticClass: "section form-column" },
                    [
                      _c(
                        "el-form",
                        {
                          attrs: {
                            disabled: _vm.viewStatus,
                            "label-width": "120px",
                            "label-position": "right"
                          }
                        },
                        [
                          !_vm.isEdit
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("AirExport.ServiceChannel")
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      no: "serviceChannel",
                                      disabled: "",
                                      "select-type":
                                        _vm.selectTypeNames
                                          .basic_data_FbaChannel,
                                      filterable: "",
                                      "method-params": {
                                        shippingType: _vm.fbaJob.shippingType,
                                        active: true
                                      },
                                      clearable: true,
                                      "default-value": _vm.fbaJob.serviceChannel
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        _vm.fbaJob.serviceChannel = p.value
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.isEdit
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("AirExport.ServiceChannel")
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        filterable: "",
                                        clearable: "",
                                        no: "138"
                                      },
                                      on: { change: _vm.changeServiceChannel },
                                      model: {
                                        value: _vm.fbaJob.serviceChannel,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.fbaJob,
                                            "serviceChannel",
                                            $$v
                                          )
                                        },
                                        expression: "fbaJob.serviceChannel"
                                      }
                                    },
                                    _vm._l(_vm.channel4JobSelect, function(
                                      item,
                                      index
                                    ) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.channelName,
                                          value: item.channelName
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "blue",
                                  attrs: { slot: "label" },
                                  slot: "label"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "AirExport.EstimatedStorageGoodArrivalTime"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  no: "preWarehousingTime",
                                  type: "datetime",
                                  clearable: "",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  format: "yyyy-MM-dd HH:mm"
                                },
                                on: { change: _vm.preWarehousingChangeHandler },
                                model: {
                                  value: _vm.fbaJob.preWarehousingTime,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.fbaJob,
                                      "preWarehousingTime",
                                      $$v
                                    )
                                  },
                                  expression: "fbaJob.preWarehousingTime"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "AirExport.ExpectedTimeIntoAmazonWarehouse"
                                )
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  no: "preAmazonWhTime",
                                  disabled: _vm.viewStatus,
                                  type: "date",
                                  clearable: "",
                                  "value-format": "yyyy-MM-dd",
                                  format: "yyyy-MM-dd"
                                },
                                model: {
                                  value: _vm.fbaJob.preAmazonWhTime,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fbaJob, "preAmazonWhTime", $$v)
                                  },
                                  expression: "fbaJob.preAmazonWhTime"
                                }
                              })
                            ],
                            1
                          ),
                          _c("el-form-item", [
                            _c(
                              "span",
                              {
                                staticClass: "blue",
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("CargoMsg.Cargo_Destination"))
                                )
                              ]
                            ),
                            _c(
                              "div",
                              { staticStyle: { display: "flex", flex: "1" } },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content: _vm.fbaJob.warehouseCode,
                                      placement: "bottom-end"
                                    }
                                  },
                                  [
                                    _c("el-cascader", {
                                      staticStyle: { "padding-right": "2px" },
                                      attrs: {
                                        options: _vm.destinations,
                                        filterable: "",
                                        clearable: true,
                                        no: "139"
                                      },
                                      on: {
                                        focus: function($event) {
                                          return _vm.JobUtils.focusWarehouseCode(
                                            _vm.fbaJob
                                          )
                                        },
                                        blur: function($event) {
                                          return _vm.JobUtils.blurWarehouseCode(
                                            _vm.fbaJob
                                          )
                                        },
                                        change: function(p) {
                                          _vm.JobUtils.warehouseCodeHandler(
                                            _vm.fbaJob,
                                            p
                                          )
                                          _vm.changeWarehouseCode
                                        }
                                      },
                                      model: {
                                        value: _vm.fbaJob.warehouseCode,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.fbaJob,
                                            "warehouseCode",
                                            $$v
                                          )
                                        },
                                        expression: "fbaJob.warehouseCode"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-checkbox",
                                  {
                                    attrs: { no: "remoteWarehouse" },
                                    model: {
                                      value: _vm.fbaJob.remoteWarehouse,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.fbaJob,
                                          "remoteWarehouse",
                                          $$v
                                        )
                                      },
                                      expression: "fbaJob.remoteWarehouse"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("AirExport.RemoteWarehouse")
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("Warehouse.DestinationCountry")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: true, no: "country" },
                                model: {
                                  value: _vm.fbaJob.country,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fbaJob, "country", $$v)
                                  },
                                  expression: "fbaJob.country"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("AirExport.ZipCode") } },
                            [
                              _c("el-input", {
                                attrs: { disabled: true, no: "zipCode" },
                                model: {
                                  value: _vm.fbaJob.zipCode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fbaJob, "zipCode", $$v)
                                  },
                                  expression: "fbaJob.zipCode"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "AirExport.DestinationDeliveryMethod"
                                )
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    no: "destinationDistribution",
                                    filterable: ""
                                  },
                                  on: {
                                    change: _vm.destinationDistributionChange
                                  },
                                  model: {
                                    value: _vm.fbaJob.destinationDistribution,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.fbaJob,
                                        "destinationDistribution",
                                        $$v
                                      )
                                    },
                                    expression: "fbaJob.destinationDistribution"
                                  }
                                },
                                _vm._l(
                                  _vm.FbaJobConstants
                                    .ORDER_DESTINATION_DISTRIBUTION_TYPES,
                                  function(item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label:
                                          _vm.$store.getters.language === "zh"
                                            ? item.chineseName
                                            : item.englishName,
                                        value: item.code
                                      }
                                    })
                                  }
                                ),
                                1
                              )
                            ],
                            1
                          ),
                          _vm.fbaJob.destinationDistribution &&
                          Number(_vm.fbaJob.destinationDistribution) === 1
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("AirExport.CourierCompany")
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        no: "expressCompany",
                                        placeholder: "",
                                        clearable: ""
                                      },
                                      model: {
                                        value: _vm.fbaJob.expressCompany,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.fbaJob,
                                            "expressCompany",
                                            $$v
                                          )
                                        },
                                        expression: "fbaJob.expressCompany"
                                      }
                                    },
                                    _vm._l(
                                      _vm.FbaJobConstants.EXPRESS_COMPANYS,
                                      function(item) {
                                        return _c("el-option", {
                                          key: item.code,
                                          attrs: {
                                            label: item.chineseName,
                                            value: item.code
                                          }
                                        })
                                      }
                                    ),
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.fbaJob.destinationDistribution &&
                          Number(_vm.fbaJob.destinationDistribution) === 1
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("AirExport.CourierNumber")
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { no: "expressNo" },
                                    model: {
                                      value: _vm.fbaJob.expressNo,
                                      callback: function($$v) {
                                        _vm.$set(_vm.fbaJob, "expressNo", $$v)
                                      },
                                      expression: "fbaJob.expressNo"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("AirExport.POOriginalOrderNumber")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "poNumber" },
                                model: {
                                  value: _vm.fbaJob.poNumber,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fbaJob, "poNumber", $$v)
                                  },
                                  expression: "fbaJob.poNumber"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "Shipment Id" } },
                            [
                              _c("el-input", {
                                attrs: { no: "shipmentId" },
                                model: {
                                  value: _vm.fbaJob.shipmentId,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fbaJob, "shipmentId", $$v)
                                  },
                                  expression: "fbaJob.shipmentId"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "Reference Id" } },
                            [
                              _c("el-input", {
                                attrs: { no: "referenceId" },
                                model: {
                                  value: _vm.fbaJob.referenceId,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fbaJob, "referenceId", $$v)
                                  },
                                  expression: "fbaJob.referenceId"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("AirExport.EORIBusinessNumber")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "eoriNo" },
                                model: {
                                  value: _vm.fbaJob.eoriNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fbaJob, "eoriNo", $$v)
                                  },
                                  expression: "fbaJob.eoriNo"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("AirExport.VATTaxNumber") }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "vatNo" },
                                model: {
                                  value: _vm.fbaJob.vatNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fbaJob, "vatNo", $$v)
                                  },
                                  expression: "fbaJob.vatNo"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "AirExport.VATRegistrationCountry"
                                )
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  no: "taxRegisterCountry",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Country,
                                  filterable: "",
                                  "callback-params": {
                                    key: "taxRegisterCountry"
                                  },
                                  "callback-method-type": "value",
                                  "default-value": _vm.fbaJob.taxRegisterCountry
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.fbaJob.taxRegisterCountry = p.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "AirExport.VATRegistrationAddress"
                                )
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "taxRegisterAddress" },
                                model: {
                                  value: _vm.fbaJob.taxRegisterAddress,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.fbaJob,
                                      "taxRegisterAddress",
                                      $$v
                                    )
                                  },
                                  expression: "fbaJob.taxRegisterAddress"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("AirExport.VATCompanyEnglishName")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "taxCompany" },
                                model: {
                                  value: _vm.fbaJob.taxCompany,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fbaJob, "taxCompany", $$v)
                                  },
                                  expression: "fbaJob.taxCompany"
                                }
                              })
                            ],
                            1
                          ),
                          _c("hr", {
                            staticStyle: {
                              "margin-top": "20px",
                              "margin-bottom": "20px"
                            }
                          }),
                          _c("span", { staticClass: "title" }, [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.PODDeliveryInformation"))
                            )
                          ]),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                title: _vm.$t(
                                  "SeaExport.DeliveryToWarehouseMessage"
                                ),
                                label: _vm.$t(
                                  "SeaExport.EstimatedDeliveryToWarehouseTime"
                                )
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  no: "estWarehouseDeliveryTime",
                                  type: "datetime",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  format: "yyyy-MM-dd HH:mm"
                                },
                                model: {
                                  value: _vm.job.estWarehouseDeliveryTime,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.job,
                                      "estWarehouseDeliveryTime",
                                      $$v
                                    )
                                  },
                                  expression: "job.estWarehouseDeliveryTime"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                title: _vm.$t(
                                  "SeaExport.DeliveryToWarehouseMessage"
                                ),
                                label: _vm.$t(
                                  "SeaExport.ActualDeliveryToWarehouseTime"
                                )
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  no: "actWarehouseDeliveryTime",
                                  type: "datetime",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  format: "yyyy-MM-dd HH:mm"
                                },
                                model: {
                                  value: _vm.job.actWarehouseDeliveryTime,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.job,
                                      "actWarehouseDeliveryTime",
                                      $$v
                                    )
                                  },
                                  expression: "job.actWarehouseDeliveryTime"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                title: _vm.$t(
                                  "SeaExport.EstimatedDeliveryToCustomersWarehouseMessage"
                                ),
                                label: _vm.$t(
                                  "SeaExport.EstimatedDeliveryToCustomersWarehouseTime"
                                )
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  no: "estGoodsDeliveryTime",
                                  type: "datetime",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  format: "yyyy-MM-dd HH:mm"
                                },
                                model: {
                                  value: _vm.job.estGoodsDeliveryTime,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.job,
                                      "estGoodsDeliveryTime",
                                      $$v
                                    )
                                  },
                                  expression: "job.estGoodsDeliveryTime"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                title: _vm.$t(
                                  "SeaExport.ActualDeliveryToCustomersWarehouseMessage"
                                ),
                                label: _vm.$t(
                                  "SeaExport.ActualDeliveryToCustomersWarehouseTime"
                                )
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  no: "actGoodsDeliveryTime",
                                  type: "datetime",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  format: "yyyy-MM-dd HH:mm"
                                },
                                model: {
                                  value: _vm.job.actGoodsDeliveryTime,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.job,
                                      "actGoodsDeliveryTime",
                                      $$v
                                    )
                                  },
                                  expression: "job.actGoodsDeliveryTime"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("AirExport.EstimatedDeliveryTime")
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  no: "estDeliveryTime",
                                  type: "datetime",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  format: "yyyy-MM-dd HH:mm"
                                },
                                model: {
                                  value: _vm.job.estDeliveryTime,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "estDeliveryTime", $$v)
                                  },
                                  expression: "job.estDeliveryTime"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("AirExport.ActualDeliveryTime")
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  no: "actDeliveryTime",
                                  type: "datetime",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  format: "yyyy-MM-dd HH:mm"
                                },
                                model: {
                                  value: _vm.job.actDeliveryTime,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "actDeliveryTime", $$v)
                                  },
                                  expression: "job.actDeliveryTime"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.userDefinedField1 &&
              _vm.elementDict.userDefinedField1.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "userDefinedField1" },
                      slot: "userDefinedField1"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.userDefinedField1.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.userDefinedField1.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled: !_vm.elementDict.userDefinedField1.writable,
                          no: "86",
                          type: "textarea",
                          rows: 5
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            return _vm.showAdvanceTextDialog(
                              _vm.elementDict.userDefinedField1.label,
                              _vm.job.userDefinedField1,
                              function(val) {
                                _vm.job.userDefinedField1 = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.job.userDefinedField1,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "userDefinedField1", $$v)
                          },
                          expression: "job.userDefinedField1"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.userDefinedField2 &&
              _vm.elementDict.userDefinedField2.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "userDefinedField2" },
                      slot: "userDefinedField2"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.userDefinedField2.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.userDefinedField2.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled: !_vm.elementDict.userDefinedField2.writable,
                          no: "87",
                          type: "textarea",
                          rows: 5
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            return _vm.showAdvanceTextDialog(
                              _vm.elementDict.userDefinedField2.label,
                              _vm.job.userDefinedField2,
                              function(val) {
                                _vm.job.userDefinedField2 = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.job.userDefinedField2,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "userDefinedField2", $$v)
                          },
                          expression: "job.userDefinedField2"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.userDefinedField3 &&
              _vm.elementDict.userDefinedField3.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "userDefinedField3" },
                      slot: "userDefinedField3"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.userDefinedField3.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.userDefinedField3.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled: !_vm.elementDict.userDefinedField3.writable,
                          no: "88",
                          type: "textarea",
                          rows: 5
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            return _vm.showAdvanceTextDialog(
                              _vm.elementDict.userDefinedField3.label,
                              _vm.job.userDefinedField3,
                              function(val) {
                                _vm.job.userDefinedField3 = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.job.userDefinedField3,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "userDefinedField3", $$v)
                          },
                          expression: "job.userDefinedField3"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.userDefinedField4 &&
              _vm.elementDict.userDefinedField4.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "userDefinedField4" },
                      slot: "userDefinedField4"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.userDefinedField4.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.userDefinedField4.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled: !_vm.elementDict.userDefinedField4.writable,
                          no: "89",
                          type: "textarea",
                          rows: 5
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            return _vm.showAdvanceTextDialog(
                              _vm.elementDict.userDefinedField4.label,
                              _vm.job.userDefinedField4,
                              function(val) {
                                _vm.job.userDefinedField4 = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.job.userDefinedField4,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "userDefinedField4", $$v)
                          },
                          expression: "job.userDefinedField4"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.exportControlledProduct &&
              _vm.elementDict.exportControlledProduct.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "exportControlledProduct" },
                      slot: "exportControlledProduct"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.exportControlledProduct.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.exportControlledProduct.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "el-select",
                        {
                          attrs: {
                            no: "exportControlledProduct",
                            disabled:
                              !_vm.isEdit ||
                              !_vm.elementDict.exportControlledProduct.writable,
                            placeholder: "",
                            clearable: true,
                            size: "mini"
                          },
                          model: {
                            value: _vm.job.exportControlledProduct,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "exportControlledProduct", $$v)
                            },
                            expression: "job.exportControlledProduct"
                          }
                        },
                        _vm._l(_vm.EXPORT_CONTROLLED_PRODUCT, function(
                          item,
                          index
                        ) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.isZh
                                ? item.chineseName
                                : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.taxNature && _vm.elementDict.taxNature.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "taxNature" }, slot: "taxNature" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.taxNature.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.taxNature.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "el-select",
                        {
                          attrs: {
                            disabled: !_vm.elementDict.taxNature.writable,
                            no: "taxNature",
                            placeholder: _vm.$t("SeaExport.PleaseSelect"),
                            size: "mini"
                          },
                          model: {
                            value: _vm.job.taxNature,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "taxNature", $$v)
                            },
                            expression: "job.taxNature"
                          }
                        },
                        _vm._l(_vm.TAX_NATURES, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.isZh
                                ? item.chineseName
                                : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.boardSales && _vm.elementDict.boardSales.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        slot: "boardSales",
                        label: _vm.$t("SeaExport.BoardSales")
                      },
                      slot: "boardSales"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.boardSales.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.boardSales.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: { disabled: true, no: "BoardSales", rows: 5 },
                        model: {
                          value: _vm.job.boardSales,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "boardSales", $$v)
                          },
                          expression: "job.boardSales"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.boardCsr && _vm.elementDict.boardCsr.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        slot: "boardCsr",
                        label: _vm.$t("SeaExport.BoardCsr")
                      },
                      slot: "boardCsr"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.boardCsr.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.boardCsr.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: { disabled: true, no: "BoardCsr", rows: 5 },
                        model: {
                          value: _vm.job.boardCsr,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "boardCsr", $$v)
                          },
                          expression: "job.boardCsr"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.boardSite && _vm.elementDict.boardSite.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        slot: "boardSite",
                        label: _vm.$t("SeaExport.BoardSite")
                      },
                      slot: "boardSite"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.boardSite.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.boardSite.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: { disabled: true, no: "BoardSite", rows: 5 },
                        model: {
                          value: _vm.job.boardSite,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "boardSite", $$v)
                          },
                          expression: "job.boardSite"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.arrivalMethod &&
              _vm.elementDict.arrivalMethod.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        slot: "arrivalMethod",
                        label: _vm.$t("SeaExport.ArrivalMethod")
                      },
                      slot: "arrivalMethod"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.arrivalMethod.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.arrivalMethod.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "el-select",
                        {
                          attrs: {
                            disabled: true,
                            placeholder: _vm.$t("Message.PleaseSelect"),
                            size: "mini",
                            no: "ArrivalMethod"
                          },
                          model: {
                            value: _vm.job.arrivalMethod,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "arrivalMethod", $$v)
                            },
                            expression: "job.arrivalMethod"
                          }
                        },
                        _vm._l(_vm.AirExportConstants.ARRIVAL_METHOD, function(
                          item,
                          index
                        ) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label:
                                _vm.$store.getters.language === "zh"
                                  ? item.chineseName
                                  : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.flightLabel &&
              _vm.elementDict.flightLabel.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        slot: "flightLabel",
                        label: _vm.$t("SeaExport.FlightLabel")
                      },
                      slot: "flightLabel"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.flightLabel.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.flightLabel.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "el-select",
                        {
                          attrs: {
                            disabled: true,
                            placeholder: _vm.$t("Message.PleaseSelect"),
                            size: "mini",
                            no: "FlightLabel"
                          },
                          model: {
                            value: _vm.job.flightLabel,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "flightLabel", $$v)
                            },
                            expression: "job.flightLabel"
                          }
                        },
                        _vm._l(
                          _vm.AirExportConstants.AIR_FLIGHT_LABEL,
                          function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label:
                                  _vm.$store.getters.language === "zh"
                                    ? item.chineseName
                                    : item.englishName,
                                value: item.code
                              }
                            })
                          }
                        ),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.showGoodsInfo
                ? _c(
                    "div",
                    {
                      staticClass: "goods-info",
                      staticStyle: { width: "1100px" },
                      attrs: { slot: "goodsInfo" },
                      slot: "goodsInfo"
                    },
                    [
                      _c("el-form-item", { staticClass: "auto-width" }, [
                        _c("div", { staticStyle: { display: "flex" } }, [
                          _c(
                            "div",
                            {
                              staticClass: "title-row",
                              staticStyle: {
                                display: "flex",
                                "text-align": "left"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "12px",
                                    "font-weight": "normal",
                                    color: "#404144",
                                    "white-space": "nowrap",
                                    width: "188px",
                                    "text-align": "right"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.Quantity")))]
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "12px",
                                    "font-weight": "normal",
                                    color: "#404144",
                                    "white-space": "nowrap",
                                    width: "200px",
                                    "text-align": "right"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.Weight")) +
                                      _vm._s(_vm.openImperial ? "LB" : "KGS")
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "12px",
                                    "font-weight": "normal",
                                    color: "#404144",
                                    "white-space": "nowrap",
                                    width: "200px",
                                    "text-align": "right"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.Cubage")) +
                                      _vm._s(_vm.openImperial ? "CFT" : "CBM")
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "12px",
                                    "font-weight": "normal",
                                    color: "#404144",
                                    "white-space": "nowrap",
                                    width: "200px",
                                    "text-align": "right"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.ChargedWeight")) +
                                      _vm._s(_vm.openImperial ? "LB" : "KGS")
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "12px",
                                    "font-weight": "normal",
                                    color: "#404144",
                                    "white-space": "nowrap",
                                    width: "200px",
                                    "text-align": "right"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("queryJob.Density")) + "kg/m³"
                                  )
                                ]
                              ),
                              _vm.isFba
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "font-size": "12px",
                                        "font-weight": "normal",
                                        color: "#404144",
                                        "white-space": "nowrap",
                                        width: "200px",
                                        "text-align": "right"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("SeaExport.VolumetricWeight")
                                        ) + "KGS"
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "12px",
                                    "font-weight": "normal",
                                    color: "#404144",
                                    "white-space": "nowrap",
                                    width: "200px",
                                    "text-align": "right"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.Size")) + "CM"
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm.showImperialButton && _vm.viewStatus
                            ? _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "12px",
                                    "font-weight": "normal",
                                    color: "#404144",
                                    "white-space": "nowrap",
                                    width: "200px",
                                    "text-align": "right",
                                    "padding-left": "50px"
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_ImperialUnits")
                                      ) +
                                      " "
                                  ),
                                  _c(
                                    "div",
                                    {
                                      class: _vm.isOpenImperial
                                        ? "el-switch is-checked"
                                        : "el-switch"
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "el-switch__core",
                                        staticStyle: { width: "40px" },
                                        on: {
                                          click: function($event) {
                                            _vm.isOpenImperial = !_vm.isOpenImperial
                                          }
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            : _vm._e()
                        ])
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.goodsInfoContract &&
              _vm.elementDict.goodsInfoContract.viewable
                ? _c(
                    "div",
                    {
                      staticClass: "goods-info",
                      staticStyle: { width: "1500px" },
                      attrs: { slot: "goodsInfoContract" },
                      slot: "goodsInfoContract"
                    },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "goods-info-item" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.goodsInfoContract.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.$t("SeaExport.Consignation")
                            },
                            slot: "label"
                          }),
                          _c("auto-number-input", {
                            class: _vm.importDifferenceField.quantityContract
                              ? "red-border"
                              : "",
                            staticStyle: { "margin-left": "0" },
                            attrs: {
                              no: "90",
                              precision: 0,
                              min: 0,
                              disabled: !_vm.elementDict.goodsInfoContract
                                .writable
                            },
                            on: {
                              change: function($event) {
                                return _vm.calcEstVolumetricAndChargeWeight(
                                  false
                                )
                              }
                            },
                            model: {
                              value: _vm.job.quantityContract,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "quantityContract", $$v)
                              },
                              expression: "job.quantityContract"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.openImperial,
                                expression: "openImperial"
                              }
                            ],
                            class: _vm.importDifferenceField.weightContract
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "weightContractImperial",
                              precision: 3,
                              min: 0,
                              disabled: !_vm.elementDict.goodsInfoContract
                                .writable
                            },
                            on: {
                              change: function($event) {
                                return _vm.weightContractImperialChange()
                              }
                            },
                            model: {
                              value: _vm.job.weightContractImperial,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "weightContractImperial", $$v)
                              },
                              expression: "job.weightContractImperial"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.openImperial,
                                expression: "openImperial"
                              }
                            ],
                            class: _vm.importDifferenceField.cubageContract
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "cubAgeContractImperial",
                              precision: 3,
                              min: 0,
                              disabled: !_vm.elementDict.goodsInfoContract
                                .writable
                            },
                            on: {
                              change: function($event) {
                                return _vm.cubAgeContractImperialChange()
                              }
                            },
                            model: {
                              value: _vm.job.cubAgeContractImperial,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "cubAgeContractImperial", $$v)
                              },
                              expression: "job.cubAgeContractImperial"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.openImperial,
                                expression: "openImperial"
                              }
                            ],
                            class: _vm.importDifferenceField.chargeWeight
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "chargeWeightImperial",
                              precision: 3,
                              min: 0,
                              disabled: true
                            },
                            model: {
                              value: _vm.job.chargeWeightImperial,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "chargeWeightImperial", $$v)
                              },
                              expression: "job.chargeWeightImperial"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.openImperial,
                                expression: "!openImperial"
                              }
                            ],
                            class: _vm.importDifferenceField.weightContract
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "91",
                              precision: 3,
                              min: 0,
                              disabled: !_vm.elementDict.goodsInfoContract
                                .writable
                            },
                            on: {
                              change: function($event) {
                                _vm.weightContractChange(true)
                                _vm.calcEstVolumetricAndChargeWeight(false)
                              }
                            },
                            model: {
                              value: _vm.job.weightContract,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "weightContract", $$v)
                              },
                              expression: "job.weightContract"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.openImperial,
                                expression: "!openImperial"
                              }
                            ],
                            class: _vm.importDifferenceField.cubageContract
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "92",
                              precision: 3,
                              min: 0,
                              disabled: !_vm.elementDict.goodsInfoContract
                                .writable
                            },
                            on: {
                              change: function($event) {
                                _vm.cubageContractChange(true)
                                _vm.calcEstVolumetricAndChargeWeight(false)
                              }
                            },
                            model: {
                              value: _vm.job.cubageContract,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "cubageContract", $$v)
                              },
                              expression: "job.cubageContract"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.openImperial,
                                expression: "!openImperial"
                              }
                            ],
                            class: _vm.importDifferenceField.chargeWeight
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "93",
                              precision: 3,
                              min: 0,
                              disabled: !_vm.elementDict.goodsInfoContract
                                .writable
                            },
                            on: {
                              change: function($event) {
                                return _vm.pm.chargeWeightImperialChange(
                                  "chargeWeight",
                                  "chargeWeightImperial"
                                )
                              }
                            },
                            model: {
                              value: _vm.job.chargeWeight,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "chargeWeight", $$v)
                              },
                              expression: "job.chargeWeight"
                            }
                          }),
                          _c("auto-number-input", {
                            class: _vm.importDifferenceField.densityContract
                              ? "red-border"
                              : "",
                            attrs: {
                              precision: 3,
                              min: 0,
                              no: "140",
                              disabled: !_vm.elementDict.goodsInfoContract
                                .writable
                            },
                            model: {
                              value: _vm.job.densityContract,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "densityContract", $$v)
                              },
                              expression: "job.densityContract"
                            }
                          }),
                          _vm.isFba
                            ? _c("auto-number-input", {
                                attrs: {
                                  no: "80",
                                  precision: 3,
                                  min: 0,
                                  disabled: true
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.calcEstVolumetricAndChargeWeight(
                                      false,
                                      _vm.job.volumetricWeightContract
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.job.volumetricWeightContract,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.job,
                                      "volumetricWeightContract",
                                      $$v
                                    )
                                  },
                                  expression: "job.volumetricWeightContract"
                                }
                              })
                            : _vm._e(),
                          _c("el-input", {
                            staticStyle: {
                              width: "200px",
                              "padding-right": "5px"
                            },
                            attrs: {
                              no: "commissionDimensions",
                              disabled: !_vm.elementDict.goodsInfoContract
                                .writable
                            },
                            model: {
                              value: _vm.job.commissionDimensions,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "commissionDimensions", $$v)
                              },
                              expression: "job.commissionDimensions"
                            }
                          }),
                          _c(
                            "el-button",
                            {
                              staticStyle: { "padding-right": "5px" },
                              attrs: {
                                disabled: _vm.viewStatus,
                                type: "primary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.commissionDimensionsChange(1)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Size")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.goodsInfoBooking &&
              _vm.elementDict.goodsInfoBooking.viewable
                ? _c(
                    "div",
                    {
                      staticClass: "goods-info",
                      staticStyle: { width: "1500px" },
                      attrs: { slot: "goodsInfoBooking" },
                      slot: "goodsInfoBooking"
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "goods-info-item",
                          attrs: { label: _vm.$t("SeaExport.Booking") }
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.goodsInfoBooking.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.$t("SeaExport.Booking")
                            },
                            slot: "label"
                          }),
                          _c("auto-number-input", {
                            class: _vm.importDifferenceField.quantityBooking
                              ? "red-border"
                              : "",
                            staticStyle: { "margin-left": "0" },
                            attrs: {
                              no: "94",
                              precision: 0,
                              min: 0,
                              disabled: !_vm.elementDict.goodsInfoBooking
                                .writable
                            },
                            on: {
                              change: function($event) {
                                _vm.pm.weightCubageChangeHandler(
                                  "quantityBooking"
                                )
                                _vm.calcEstVolumetricAndChargeWeight(true)
                              }
                            },
                            model: {
                              value: _vm.job.quantityBooking,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "quantityBooking", $$v)
                              },
                              expression: "job.quantityBooking"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.openImperial,
                                expression: "openImperial"
                              }
                            ],
                            class: _vm.importDifferenceField.weightBooking
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "weightBookingImperial",
                              precision: 3,
                              min: 0,
                              disabled: !_vm.elementDict.goodsInfoBooking
                                .writable
                            },
                            on: {
                              change: function($event) {
                                return _vm.pm.weightCubAgeImperialChangeHandler(
                                  "weightBooking"
                                )
                              }
                            },
                            model: {
                              value: _vm.job.weightBookingImperial,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "weightBookingImperial", $$v)
                              },
                              expression: "job.weightBookingImperial"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.openImperial,
                                expression: "openImperial"
                              }
                            ],
                            class: _vm.importDifferenceField.cubageBooking
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "cubAgeBookingImperial",
                              precision: 3,
                              min: 0,
                              disabled: !_vm.elementDict.goodsInfoBooking
                                .writable
                            },
                            on: {
                              change: function($event) {
                                return _vm.pm.weightCubAgeImperialChangeHandler(
                                  "cubageBooking"
                                )
                              }
                            },
                            model: {
                              value: _vm.job.cubAgeBookingImperial,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "cubAgeBookingImperial", $$v)
                              },
                              expression: "job.cubAgeBookingImperial"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.openImperial,
                                expression: "openImperial"
                              }
                            ],
                            class: _vm.importDifferenceField.chargeWeightBooking
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "chargeWeightBookingImperial",
                              precision: 3,
                              min: 0,
                              disabled: true
                            },
                            model: {
                              value: _vm.job.chargeWeightBookingImperial,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.job,
                                  "chargeWeightBookingImperial",
                                  $$v
                                )
                              },
                              expression: "job.chargeWeightBookingImperial"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.openImperial,
                                expression: "!openImperial"
                              }
                            ],
                            class: _vm.importDifferenceField.weightBooking
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "95",
                              precision: 3,
                              min: 0,
                              disabled: !_vm.elementDict.goodsInfoBooking
                                .writable
                            },
                            on: {
                              change: function($event) {
                                _vm.pm.doWeightCubAgeChangeHandler(
                                  "weightBooking"
                                )
                                _vm.calcEstVolumetricAndChargeWeight(true)
                              }
                            },
                            model: {
                              value: _vm.job.weightBooking,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "weightBooking", $$v)
                              },
                              expression: "job.weightBooking"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.openImperial,
                                expression: "!openImperial"
                              }
                            ],
                            class: _vm.importDifferenceField.cubageBooking
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "96",
                              precision: 3,
                              min: 0,
                              disabled: !_vm.elementDict.goodsInfoBooking
                                .writable
                            },
                            on: {
                              change: function($event) {
                                _vm.pm.doWeightCubAgeChangeHandler(
                                  "cubageBooking"
                                )
                                _vm.calcEstVolumetricAndChargeWeight(true)
                              }
                            },
                            model: {
                              value: _vm.job.cubageBooking,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "cubageBooking", $$v)
                              },
                              expression: "job.cubageBooking"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.openImperial,
                                expression: "!openImperial"
                              }
                            ],
                            class: _vm.importDifferenceField.chargeWeightBooking
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "97",
                              precision: 3,
                              min: 0,
                              disabled: !_vm.elementDict.goodsInfoBooking
                                .writable
                            },
                            on: {
                              change: function($event) {
                                return _vm.pm.chargeWeightImperialChange(
                                  "chargeWeightBooking",
                                  "chargeWeightBookingImperial"
                                )
                              }
                            },
                            model: {
                              value: _vm.job.chargeWeightBooking,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "chargeWeightBooking", $$v)
                              },
                              expression: "job.chargeWeightBooking"
                            }
                          }),
                          _c("auto-number-input", {
                            class: _vm.importDifferenceField.densityBooking
                              ? "red-border"
                              : "",
                            attrs: {
                              precision: 3,
                              min: 0,
                              no: "141",
                              disabled: !_vm.elementDict.goodsInfoBooking
                                .writable
                            },
                            model: {
                              value: _vm.job.densityBooking,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "densityBooking", $$v)
                              },
                              expression: "job.densityBooking"
                            }
                          }),
                          _vm.isFba
                            ? _c("auto-number-input", {
                                attrs: {
                                  no: "81",
                                  precision: 3,
                                  min: 0,
                                  disabled: true
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.calcEstVolumetricAndChargeWeight(
                                      true,
                                      _vm.job.volumetricWeightBooking
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.job.volumetricWeightBooking,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.job,
                                      "volumetricWeightBooking",
                                      $$v
                                    )
                                  },
                                  expression: "job.volumetricWeightBooking"
                                }
                              })
                            : _vm._e(),
                          _c("el-input", {
                            staticStyle: {
                              width: "200px",
                              "padding-right": "5px"
                            },
                            attrs: {
                              no: "measurements",
                              disabled: !_vm.elementDict.goodsInfoBooking
                                .writable
                            },
                            on: {
                              input: function($event) {
                                return _vm.pm.weightCubageChangeHandler(
                                  "measurements"
                                )
                              }
                            },
                            model: {
                              value: _vm.job.measurements,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "measurements", $$v)
                              },
                              expression: "job.measurements"
                            }
                          }),
                          _c(
                            "el-button",
                            {
                              staticStyle: { "padding-right": "5px" },
                              attrs: {
                                disabled: _vm.viewStatus,
                                type: "primary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.commissionDimensionsChange(2)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Size")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.goodsInfoActual &&
              _vm.elementDict.goodsInfoActual.viewable
                ? _c(
                    "div",
                    {
                      staticClass: "goods-info",
                      staticStyle: { width: "1500px" },
                      attrs: { slot: "goodsInfoActual" },
                      slot: "goodsInfoActual"
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "goods-info-item",
                          attrs: { label: _vm.$t("SeaExport.FrontCabinActual") }
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.goodsInfoActual.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.$t("SeaExport.FrontCabinActual")
                            },
                            slot: "label"
                          }),
                          _c("auto-number-input", {
                            class: _vm.importDifferenceField.quantityActual
                              ? "red-border"
                              : "",
                            staticStyle: { "margin-left": "0" },
                            attrs: {
                              no: "98",
                              precision: 0,
                              min: 0,
                              disabled: !_vm.elementDict.goodsInfoActual
                                .writable
                            },
                            on: {
                              change: function($event) {
                                _vm.pm.weightCubageChangeHandler(
                                  "quantityActual"
                                )
                                _vm.quantityActualChange()
                              }
                            },
                            model: {
                              value: _vm.job.quantityActual,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "quantityActual", $$v)
                              },
                              expression: "job.quantityActual"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.openImperial,
                                expression: "openImperial"
                              }
                            ],
                            class: _vm.importDifferenceField.weightActual
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "weightActualImperial",
                              precision: 3,
                              min: 0,
                              disabled: !_vm.elementDict.goodsInfoActual
                                .writable
                            },
                            on: { change: _vm.weightActualImperialChange },
                            model: {
                              value: _vm.job.weightActualImperial,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "weightActualImperial", $$v)
                              },
                              expression: "job.weightActualImperial"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.openImperial,
                                expression: "openImperial"
                              }
                            ],
                            class: _vm.importDifferenceField.cubageActual
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "cubAgeActualImperial",
                              precision: 3,
                              min: 0,
                              disabled: !_vm.elementDict.goodsInfoActual
                                .writable
                            },
                            on: { change: _vm.cubAgeActualImperialChange },
                            model: {
                              value: _vm.job.cubAgeActualImperial,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "cubAgeActualImperial", $$v)
                              },
                              expression: "job.cubAgeActualImperial"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.openImperial,
                                expression: "openImperial"
                              }
                            ],
                            class: _vm.importDifferenceField.cWeight
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "cWeightImperial",
                              precision: 3,
                              min: 0,
                              disabled: true
                            },
                            model: {
                              value: _vm.job.cWeightImperial,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "cWeightImperial", $$v)
                              },
                              expression: "job.cWeightImperial"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.openImperial,
                                expression: "!openImperial"
                              }
                            ],
                            class: _vm.importDifferenceField.weightActual
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "99",
                              precision: 3,
                              min: 0,
                              disabled: !_vm.elementDict.goodsInfoActual
                                .writable
                            },
                            on: {
                              change: function($event) {
                                return _vm.weightActualChange(true)
                              }
                            },
                            model: {
                              value: _vm.job.weightActual,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "weightActual", $$v)
                              },
                              expression: "job.weightActual"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.openImperial,
                                expression: "!openImperial"
                              }
                            ],
                            class: _vm.importDifferenceField.cubageActual
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "100",
                              precision: 3,
                              min: 0,
                              disabled: !_vm.elementDict.goodsInfoActual
                                .writable
                            },
                            on: {
                              change: function($event) {
                                return _vm.cubageActualChange(true)
                              }
                            },
                            model: {
                              value: _vm.job.cubageActual,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "cubageActual", $$v)
                              },
                              expression: "job.cubageActual"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.openImperial,
                                expression: "!openImperial"
                              }
                            ],
                            class: _vm.importDifferenceField.cWeight
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "101",
                              precision: 3,
                              min: 0,
                              disabled: !_vm.elementDict.goodsInfoActual
                                .writable
                            },
                            on: {
                              change: function($event) {
                                _vm.isFba
                                  ? _vm.changeChargeWeight
                                  : _vm.pm.weightCubageChangeHandler(
                                      "chargeWeightActual"
                                    )
                              }
                            },
                            model: {
                              value: _vm.job.cWeight,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "cWeight", $$v)
                              },
                              expression: "job.cWeight"
                            }
                          }),
                          _c("auto-number-input", {
                            class: _vm.importDifferenceField.densityActual
                              ? "red-border"
                              : "",
                            attrs: {
                              precision: 3,
                              min: 0,
                              no: "142",
                              disabled: !_vm.elementDict.goodsInfoActual
                                .writable
                            },
                            model: {
                              value: _vm.job.densityActual,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "densityActual", $$v)
                              },
                              expression: "job.densityActual"
                            }
                          }),
                          _vm.isFba
                            ? _c("auto-number-input", {
                                attrs: {
                                  no: "82",
                                  precision: 3,
                                  min: 0,
                                  disabled: true
                                },
                                on: { change: _vm.changeVolumetricWeight },
                                model: {
                                  value: _vm.job.volumetricWeight,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "volumetricWeight", $$v)
                                  },
                                  expression: "job.volumetricWeight"
                                }
                              })
                            : _vm._e(),
                          _c("el-input", {
                            staticStyle: {
                              width: "200px",
                              "padding-right": "5px"
                            },
                            attrs: {
                              no: "dimensionsActual",
                              disabled: !_vm.elementDict.goodsInfoActual
                                .writable
                            },
                            on: {
                              input: function($event) {
                                return _vm.pm.weightCubageChangeHandler(
                                  "dimensionsActual"
                                )
                              }
                            },
                            model: {
                              value: _vm.job.dimensionsActual,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "dimensionsActual", $$v)
                              },
                              expression: "job.dimensionsActual"
                            }
                          }),
                          _c(
                            "el-button",
                            {
                              staticStyle: { "padding-right": "5px" },
                              attrs: {
                                disabled: _vm.viewStatus,
                                type: "primary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.commissionDimensionsChange(3)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Size")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.goodsInfoDocument &&
              _vm.elementDict.goodsInfoDocument.viewable &&
              _vm.job.operateType !== 0
                ? _c(
                    "div",
                    {
                      staticClass: "goods-info",
                      staticStyle: { width: "1500px" },
                      attrs: { slot: "goodsInfoDocument" },
                      slot: "goodsInfoDocument"
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "goods-info-item",
                          attrs: { label: _vm.$t("SeaExport.Documentation") }
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.goodsInfoDocument.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.$t("SeaExport.Documentation")
                            },
                            slot: "label"
                          }),
                          _c("auto-number-input", {
                            staticStyle: { "margin-left": "0" },
                            attrs: {
                              no: "102",
                              precision: 0,
                              min: 0,
                              disabled: !_vm.elementDict.goodsInfoDocument
                                .writable
                            },
                            on: {
                              change: function($event) {
                                _vm.pm.weightCubageChangeHandler("quantityMBL")
                                _vm.calcActVolumetricAndChargeWeight(true)
                              }
                            },
                            model: {
                              value: _vm.mawbDoc.quantity,
                              callback: function($$v) {
                                _vm.$set(_vm.mawbDoc, "quantity", $$v)
                              },
                              expression: "mawbDoc.quantity"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.openImperial,
                                expression: "openImperial"
                              }
                            ],
                            attrs: {
                              no: "weightImperial",
                              precision: 3,
                              min: 0,
                              disabled: !_vm.elementDict.goodsInfoDocument
                                .writable
                            },
                            on: {
                              change: function($event) {
                                return _vm.pm.weightCubAgeImperialChangeHandler(
                                  "weightMBL"
                                )
                              }
                            },
                            model: {
                              value: _vm.mawbDoc.weightImperial,
                              callback: function($$v) {
                                _vm.$set(_vm.mawbDoc, "weightImperial", $$v)
                              },
                              expression: "mawbDoc.weightImperial"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.openImperial,
                                expression: "openImperial"
                              }
                            ],
                            attrs: {
                              no: "cubAgeImperial",
                              precision: 3,
                              min: 0,
                              disabled: !_vm.elementDict.goodsInfoDocument
                                .writable
                            },
                            on: {
                              change: function($event) {
                                return _vm.pm.weightCubAgeImperialChangeHandler(
                                  "cubageMBL"
                                )
                              }
                            },
                            model: {
                              value: _vm.mawbDoc.cubAgeImperial,
                              callback: function($$v) {
                                _vm.$set(_vm.mawbDoc, "cubAgeImperial", $$v)
                              },
                              expression: "mawbDoc.cubAgeImperial"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.openImperial,
                                expression: "openImperial"
                              }
                            ],
                            attrs: {
                              no: "chargeWeightImperial",
                              precision: 3,
                              min: 0,
                              disabled: true
                            },
                            model: {
                              value: _vm.mawbDoc.chargeWeightImperial,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.mawbDoc,
                                  "chargeWeightImperial",
                                  $$v
                                )
                              },
                              expression: "mawbDoc.chargeWeightImperial"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.openImperial,
                                expression: "!openImperial"
                              }
                            ],
                            attrs: {
                              no: "103",
                              precision: 3,
                              min: 0,
                              disabled: !_vm.elementDict.goodsInfoDocument
                                .writable
                            },
                            on: {
                              change: function($event) {
                                _vm.pm.doWeightCubAgeChangeHandler("weightMBL")
                                _vm.calcActVolumetricAndChargeWeight(true)
                              }
                            },
                            model: {
                              value: _vm.mawbDoc.weight,
                              callback: function($$v) {
                                _vm.$set(_vm.mawbDoc, "weight", $$v)
                              },
                              expression: "mawbDoc.weight"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.openImperial,
                                expression: "!openImperial"
                              }
                            ],
                            attrs: {
                              no: "104",
                              precision: 3,
                              min: 0,
                              disabled: !_vm.elementDict.goodsInfoDocument
                                .writable
                            },
                            on: {
                              change: function($event) {
                                _vm.pm.doWeightCubAgeChangeHandler("cubageMBL")
                                _vm.calcActVolumetricAndChargeWeight(true)
                              }
                            },
                            model: {
                              value: _vm.mawbDoc.cubage,
                              callback: function($$v) {
                                _vm.$set(_vm.mawbDoc, "cubage", $$v)
                              },
                              expression: "mawbDoc.cubage"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.openImperial,
                                expression: "!openImperial"
                              }
                            ],
                            attrs: {
                              no: "105",
                              precision: 3,
                              min: 0,
                              disabled: !_vm.elementDict.goodsInfoDocument
                                .writable
                            },
                            on: {
                              change: function($event) {
                                return _vm.pm.doWeightCubAgeChangeHandler(
                                  "chargeWeightMBL"
                                )
                              }
                            },
                            model: {
                              value: _vm.mawbDoc.cWeight,
                              callback: function($$v) {
                                _vm.$set(_vm.mawbDoc, "cWeight", $$v)
                              },
                              expression: "mawbDoc.cWeight"
                            }
                          }),
                          _c("auto-number-input", {
                            class: _vm.importDifferenceField.densityDoc
                              ? "red-border"
                              : "",
                            attrs: {
                              precision: 3,
                              min: 0,
                              no: "143",
                              disabled: !_vm.elementDict.goodsInfoDocument
                                .writable
                            },
                            model: {
                              value: _vm.job.densityDoc,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "densityDoc", $$v)
                              },
                              expression: "job.densityDoc"
                            }
                          }),
                          _vm.isFba
                            ? _c("auto-number-input", {
                                attrs: {
                                  no: "82",
                                  precision: 3,
                                  min: 0,
                                  disabled: true
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.calcActVolumetricAndChargeWeight(
                                      true,
                                      _vm.mawbDoc.volumetricWeight
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.mawbDoc.volumetricWeight,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.mawbDoc,
                                      "volumetricWeight",
                                      $$v
                                    )
                                  },
                                  expression: "mawbDoc.volumetricWeight"
                                }
                              })
                            : _vm._e(),
                          _c("el-input", {
                            staticStyle: {
                              width: "200px",
                              "padding-right": "5px"
                            },
                            attrs: {
                              no: "docDimensions",
                              disabled: !_vm.elementDict.goodsInfoDocument
                                .writable
                            },
                            model: {
                              value: _vm.job.docDimensions,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "docDimensions", $$v)
                              },
                              expression: "job.docDimensions"
                            }
                          }),
                          _c(
                            "el-button",
                            {
                              staticStyle: { "padding-right": "5px" },
                              attrs: {
                                disabled: _vm.viewStatus,
                                type: "primary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.commissionDimensionsChange(6)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Size")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.quantityStation &&
              _vm.elementDict.quantityStation.viewable
                ? _c(
                    "div",
                    {
                      staticClass: "goods-info",
                      staticStyle: { width: "1500px" },
                      attrs: { slot: "quantityStation" },
                      slot: "quantityStation"
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "goods-info-item",
                          attrs: { label: _vm.$t("SeaExport.FreightStation") }
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.quantityStation.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.$t("SeaExport.FreightStation")
                            },
                            slot: "label"
                          }),
                          _c("auto-number-input", {
                            class: _vm.importDifferenceField.quantityStation
                              ? "red-border"
                              : "",
                            staticStyle: { "margin-left": "0" },
                            attrs: {
                              no: "150",
                              precision: 0,
                              min: 0,
                              disabled: !_vm.elementDict.quantityStation
                                .writable
                            },
                            on: {
                              change: function($event) {
                                _vm.pm.weightCubageChangeHandler(
                                  "quantityStation"
                                )
                                _vm.calcStationVolumetricAndChargeWeight()
                              }
                            },
                            model: {
                              value: _vm.job.quantityStation,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "quantityStation", $$v)
                              },
                              expression: "job.quantityStation"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.openImperial,
                                expression: "openImperial"
                              }
                            ],
                            class: _vm.importDifferenceField.weightStation
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "weightStationImperial",
                              precision: 2,
                              min: 0,
                              disabled: !_vm.elementDict.quantityStation
                                .writable
                            },
                            on: {
                              change: function($event) {
                                return _vm.weightStationImperialChange()
                              }
                            },
                            model: {
                              value: _vm.job.weightStationImperial,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "weightStationImperial", $$v)
                              },
                              expression: "job.weightStationImperial"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.openImperial,
                                expression: "openImperial"
                              }
                            ],
                            class: _vm.importDifferenceField.cubageStation
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "cubAgeStationImperial",
                              precision: 3,
                              min: 0,
                              disabled: !_vm.elementDict.quantityStation
                                .writable
                            },
                            on: {
                              change: function($event) {
                                return _vm.cubAgeStationImperialChange()
                              }
                            },
                            model: {
                              value: _vm.job.cubAgeStationImperial,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "cubAgeStationImperial", $$v)
                              },
                              expression: "job.cubAgeStationImperial"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.openImperial,
                                expression: "openImperial"
                              }
                            ],
                            attrs: {
                              no: "chargeWeightStationImperial",
                              precision: 3,
                              min: 0,
                              disabled: true
                            },
                            model: {
                              value: _vm.job.chargeWeightStationImperial,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.job,
                                  "chargeWeightStationImperial",
                                  $$v
                                )
                              },
                              expression: "job.chargeWeightStationImperial"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.openImperial,
                                expression: "!openImperial"
                              }
                            ],
                            class: _vm.importDifferenceField.weightStation
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "151",
                              precision: 3,
                              min: 0,
                              disabled: !_vm.elementDict.quantityStation
                                .writable
                            },
                            on: {
                              change: function($event) {
                                _vm.weightStationChange(true)
                                _vm.calcStationVolumetricAndChargeWeight()
                              }
                            },
                            model: {
                              value: _vm.job.weightStation,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "weightStation", $$v)
                              },
                              expression: "job.weightStation"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.openImperial,
                                expression: "!openImperial"
                              }
                            ],
                            class: _vm.importDifferenceField.cubageStation
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "152",
                              precision: 3,
                              min: 0,
                              disabled: !_vm.elementDict.quantityStation
                                .writable
                            },
                            on: {
                              change: function($event) {
                                _vm.cubageStationChange(true)
                                _vm.calcStationVolumetricAndChargeWeight()
                              }
                            },
                            model: {
                              value: _vm.job.cubageStation,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "cubageStation", $$v)
                              },
                              expression: "job.cubageStation"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.openImperial,
                                expression: "!openImperial"
                              }
                            ],
                            attrs: {
                              no: "153",
                              precision: 3,
                              min: 0,
                              disabled: !_vm.elementDict.quantityStation
                                .writable
                            },
                            on: {
                              change: function($event) {
                                return _vm.pm.chargeWeightImperialChange(
                                  "chargeWeightStation",
                                  "chargeWeightStationImperial"
                                )
                              }
                            },
                            model: {
                              value: _vm.job.chargeWeightStation,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "chargeWeightStation", $$v)
                              },
                              expression: "job.chargeWeightStation"
                            }
                          }),
                          _c("auto-number-input", {
                            attrs: {
                              precision: 3,
                              min: 0,
                              disabled: !_vm.elementDict.quantityStation
                                .writable,
                              no: "154"
                            },
                            model: {
                              value: _vm.job.densityStation,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "densityStation", $$v)
                              },
                              expression: "job.densityStation"
                            }
                          }),
                          _vm.isFba
                            ? _c("auto-number-input", {
                                attrs: {
                                  no: "155",
                                  precision: 3,
                                  min: 0,
                                  disabled: true
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.calcStationVolumetricAndChargeWeight(
                                      _vm.job.volumetricWeightStation
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.job.volumetricWeightStation,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.job,
                                      "volumetricWeightStation",
                                      $$v
                                    )
                                  },
                                  expression: "job.volumetricWeightStation"
                                }
                              })
                            : _vm._e(),
                          _c("el-input", {
                            staticStyle: {
                              width: "200px",
                              "padding-right": "5px"
                            },
                            attrs: {
                              no: "freightStationDimensions",
                              disabled: !_vm.elementDict.quantityStation
                                .writable
                            },
                            on: {
                              input: function($event) {
                                return _vm.pm.weightCubageChangeHandler(
                                  "freightStationDimensions"
                                )
                              }
                            },
                            model: {
                              value: _vm.job.freightStationDimensions,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.job,
                                  "freightStationDimensions",
                                  $$v
                                )
                              },
                              expression: "job.freightStationDimensions"
                            }
                          }),
                          _c(
                            "el-button",
                            {
                              staticStyle: { "padding-right": "5px" },
                              attrs: {
                                disabled: _vm.viewStatus,
                                type: "primary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.commissionDimensionsChange(4)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Size")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.quantitySigning &&
              _vm.elementDict.quantitySigning.viewable
                ? _c(
                    "div",
                    {
                      staticClass: "goods-info",
                      staticStyle: { width: "1500px" },
                      attrs: { slot: "quantitySigning" },
                      slot: "quantitySigning"
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "goods-info-item",
                          attrs: { label: _vm.$t("SeaExport.SignBill") }
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.quantitySigning.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.$t("SeaExport.SignBill")
                            },
                            slot: "label"
                          }),
                          _c("auto-number-input", {
                            class: _vm.importDifferenceField.quantitySigning
                              ? "red-border"
                              : "",
                            staticStyle: { "margin-left": "0" },
                            attrs: {
                              no: "156",
                              precision: 0,
                              min: 0,
                              disabled: !_vm.elementDict.quantitySigning
                                .writable
                            },
                            on: {
                              change: function($event) {
                                _vm.pm.weightCubageChangeHandler(
                                  "quantitySigning"
                                )
                                _vm.calcSigningVolumetricAndChargeWeight()
                              }
                            },
                            model: {
                              value: _vm.job.quantitySigning,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "quantitySigning", $$v)
                              },
                              expression: "job.quantitySigning"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.openImperial,
                                expression: "openImperial"
                              }
                            ],
                            class: _vm.importDifferenceField.weightSigning
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "weightSigningImperial",
                              precision: 2,
                              min: 0,
                              disabled: !_vm.elementDict.quantitySigning
                                .writable
                            },
                            on: {
                              change: function($event) {
                                return _vm.weightSigningImperialChange()
                              }
                            },
                            model: {
                              value: _vm.job.weightSigningImperial,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "weightSigningImperial", $$v)
                              },
                              expression: "job.weightSigningImperial"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.openImperial,
                                expression: "openImperial"
                              }
                            ],
                            class: _vm.importDifferenceField.cubageSigning
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "cubAgeSigningImperial",
                              precision: 3,
                              min: 0,
                              disabled: !_vm.elementDict.quantitySigning
                                .writable
                            },
                            on: {
                              change: function($event) {
                                return _vm.cubAgeSigningImperialChange()
                              }
                            },
                            model: {
                              value: _vm.job.cubAgeSigningImperial,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "cubAgeSigningImperial", $$v)
                              },
                              expression: "job.cubAgeSigningImperial"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.openImperial,
                                expression: "openImperial"
                              }
                            ],
                            class: _vm.importDifferenceField.chargeWeightSigning
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "chargeWeightSigningImperial",
                              precision: 3,
                              min: 0,
                              disabled: true
                            },
                            model: {
                              value: _vm.job.chargeWeightSigningImperial,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.job,
                                  "chargeWeightSigningImperial",
                                  $$v
                                )
                              },
                              expression: "job.chargeWeightSigningImperial"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.openImperial,
                                expression: "!openImperial"
                              }
                            ],
                            class: _vm.importDifferenceField.weightSigning
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "157",
                              precision: 3,
                              min: 0,
                              disabled: !_vm.elementDict.quantitySigning
                                .writable
                            },
                            on: {
                              change: function($event) {
                                _vm.weightSigningChange(true)
                                _vm.calcSigningVolumetricAndChargeWeight()
                              }
                            },
                            model: {
                              value: _vm.job.weightSigning,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "weightSigning", $$v)
                              },
                              expression: "job.weightSigning"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.openImperial,
                                expression: "!openImperial"
                              }
                            ],
                            class: _vm.importDifferenceField.cubageSigning
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "158",
                              precision: 3,
                              min: 0,
                              disabled: !_vm.elementDict.quantitySigning
                                .writable
                            },
                            on: {
                              change: function($event) {
                                _vm.cubageSigningChange(true)
                                _vm.calcSigningVolumetricAndChargeWeight()
                              }
                            },
                            model: {
                              value: _vm.job.cubageSigning,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "cubageSigning", $$v)
                              },
                              expression: "job.cubageSigning"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.openImperial,
                                expression: "!openImperial"
                              }
                            ],
                            class: _vm.importDifferenceField.chargeWeightSigning
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "159",
                              precision: 3,
                              min: 0,
                              disabled: !_vm.elementDict.quantitySigning
                                .writable
                            },
                            on: {
                              change: function($event) {
                                return _vm.pm.chargeWeightImperialChange(
                                  "chargeWeightSigning",
                                  "chargeWeightSigningImperial"
                                )
                              }
                            },
                            model: {
                              value: _vm.job.chargeWeightSigning,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "chargeWeightSigning", $$v)
                              },
                              expression: "job.chargeWeightSigning"
                            }
                          }),
                          _c("auto-number-input", {
                            class: _vm.importDifferenceField.densitySigning
                              ? "red-border"
                              : "",
                            attrs: {
                              precision: 3,
                              min: 0,
                              no: "160",
                              disabled: !_vm.elementDict.quantitySigning
                                .writable
                            },
                            model: {
                              value: _vm.job.densitySigning,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "densitySigning", $$v)
                              },
                              expression: "job.densitySigning"
                            }
                          }),
                          _vm.isFba
                            ? _c("auto-number-input", {
                                attrs: {
                                  no: "161",
                                  precision: 3,
                                  min: 0,
                                  disabled: true
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.calcSigningVolumetricAndChargeWeight(
                                      _vm.job.volumetricWeightSigning
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.job.volumetricWeightSigning,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.job,
                                      "volumetricWeightSigning",
                                      $$v
                                    )
                                  },
                                  expression: "job.volumetricWeightSigning"
                                }
                              })
                            : _vm._e(),
                          _c("el-input", {
                            staticStyle: {
                              width: "200px",
                              "padding-right": "5px"
                            },
                            attrs: {
                              no: "dimensionsSigning",
                              disabled: !_vm.elementDict.quantitySigning
                                .writable
                            },
                            on: {
                              input: function($event) {
                                return _vm.pm.weightCubageChangeHandler(
                                  "dimensionsSigning"
                                )
                              }
                            },
                            model: {
                              value: _vm.job.dimensionsSigning,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "dimensionsSigning", $$v)
                              },
                              expression: "job.dimensionsSigning"
                            }
                          }),
                          _c(
                            "el-button",
                            {
                              staticStyle: { "padding-right": "5px" },
                              attrs: {
                                disabled: _vm.viewStatus,
                                type: "primary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.commissionDimensionsChange(5)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Size")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isFba
                ? [
                    _vm.elementDict.packing && _vm.elementDict.packing.viewable
                      ? _c(
                          "el-form-item",
                          {
                            staticStyle: { width: "fit-content" },
                            attrs: { slot: "packing" },
                            slot: "packing"
                          },
                          [
                            _c("line-label", {
                              class: _vm.elementDict.packing.isRequire
                                ? "blue"
                                : "",
                              attrs: {
                                slot: "label",
                                label: _vm.elementDict.packing.label
                              },
                              slot: "label"
                            }),
                            _c("cargo-packing-select", {
                              class: _vm.importDifferenceField.packing
                                ? "red-border"
                                : "",
                              staticStyle: { width: "186px" },
                              attrs: {
                                no: "106",
                                "default-value": _vm.job.packing,
                                "callback-params": {},
                                disabled: !_vm.elementDict.packing.writable,
                                placeholder: " "
                              },
                              on: {
                                change: function(p) {
                                  p.key = "packing"
                                  _vm.setJobSelectValue(p)
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.elementDict.pbProportion &&
                    _vm.elementDict.pbProportion.viewable
                      ? _c(
                          "el-form-item",
                          {
                            staticStyle: { width: "fit-content" },
                            attrs: {
                              slot: "pbProportion",
                              "label-width": "95px"
                            },
                            slot: "pbProportion"
                          },
                          [
                            _c("line-label", {
                              class: _vm.elementDict.pbProportion.isRequire
                                ? "blue"
                                : "",
                              attrs: {
                                slot: "label",
                                label: _vm.elementDict.pbProportion.label
                              },
                              slot: "label"
                            }),
                            _vm.splitBubbleCollectionFormat
                              ? _c(
                                  "el-select",
                                  {
                                    class: _vm.importDifferenceField
                                      .pbProportion
                                      ? "red-border"
                                      : "",
                                    attrs: {
                                      value: _vm.job.pbProportion || "",
                                      disabled: !_vm.elementDict.pbProportion
                                        .writable,
                                      no: "107",
                                      clearable: "",
                                      filterable: !_vm.pbProportionCheck,
                                      "allow-create": !_vm.pbProportionCheck
                                    },
                                    on: {
                                      focus: _vm.onPbProportionFocus,
                                      input: function(val) {
                                        _vm.job.pbProportion = val
                                      },
                                      change: function($event) {
                                        return _vm.pm.weightCubageChangeHandler(
                                          "pbProportion"
                                        )
                                      }
                                    }
                                  },
                                  _vm._l(
                                    _vm.SPLIT_BUBBLE_COLLECT_ITEMS,
                                    function(item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: _vm.$getLangColumn(item),
                                          value: item.code
                                        }
                                      })
                                    }
                                  ),
                                  1
                                )
                              : [
                                  _c("el-input-number", {
                                    staticStyle: { width: "95px" },
                                    attrs: {
                                      disabled: !_vm.elementDict.pbProportion
                                        .writable,
                                      no: "107",
                                      "controls-position": "right",
                                      min: 0,
                                      max: 999999999
                                    },
                                    on: {
                                      input: function(val) {
                                        _vm.job.pbProportion
                                      },
                                      change: function($event) {
                                        return _vm.pm.weightCubageChangeHandler(
                                          "pbProportion"
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.job.pbProportion,
                                      callback: function($$v) {
                                        _vm.$set(_vm.job, "pbProportion", $$v)
                                      },
                                      expression: "job.pbProportion"
                                    }
                                  }),
                                  _c("span", [_vm._v("%")])
                                ]
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm.elementDict.pbProportion2 &&
                    _vm.elementDict.pbProportion2.viewable
                      ? _c(
                          "el-form-item",
                          {
                            staticStyle: {
                              "margin-left": "10px",
                              width: "fit-content"
                            },
                            attrs: {
                              slot: "pbProportion2",
                              "label-width": "94px"
                            },
                            slot: "pbProportion2"
                          },
                          [
                            _c("line-label", {
                              class: _vm.elementDict.pbProportion2.isRequire
                                ? "blue"
                                : "",
                              attrs: {
                                slot: "label",
                                label: _vm.elementDict.pbProportion2.label
                              },
                              slot: "label"
                            }),
                            _vm.splitBubbleCollectionFormat
                              ? _c(
                                  "el-select",
                                  {
                                    class: _vm.importDifferenceField
                                      .pbProportion2
                                      ? "red-border"
                                      : "",
                                    attrs: {
                                      value: _vm.job.pbProportion2 || "",
                                      no: "108",
                                      clearable: "",
                                      disabled: !_vm.elementDict.pbProportion2
                                        .writable,
                                      filterable: !_vm.pbProportion2Check,
                                      "allow-create": !_vm.pbProportion2Check
                                    },
                                    on: {
                                      focus: _vm.onPbProportion2Focus,
                                      input: function(val) {
                                        _vm.job.pbProportion2 = val
                                      },
                                      change: function($event) {
                                        return _vm.pm.weightCubageChangeHandler(
                                          "pbProportion2"
                                        )
                                      }
                                    }
                                  },
                                  _vm._l(
                                    _vm.SPLIT_BUBBLE_COLLECT_ITEMS,
                                    function(item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: _vm.$getLangColumn(item),
                                          value: item.code
                                        }
                                      })
                                    }
                                  ),
                                  1
                                )
                              : [
                                  _c("el-input-number", {
                                    staticStyle: { width: "85px" },
                                    attrs: {
                                      disabled: !_vm.elementDict.pbProportion2
                                        .writable,
                                      no: "108",
                                      "controls-position": "right",
                                      min: 0,
                                      max: 999999999
                                    },
                                    on: {
                                      input: function(val) {
                                        _vm.job.pbProportion2
                                      },
                                      change: function($event) {
                                        return _vm.pm.weightCubageChangeHandler(
                                          "pbProportion2"
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.job.pbProportion2,
                                      callback: function($$v) {
                                        _vm.$set(_vm.job, "pbProportion2", $$v)
                                      },
                                      expression: "job.pbProportion2"
                                    }
                                  }),
                                  _c("span", [_vm._v("%")])
                                ]
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm.elementDict.slac && _vm.elementDict.slac.viewable
                      ? _c(
                          "el-form-item",
                          {
                            staticStyle: {
                              "margin-left": "10px",
                              width: "fit-content"
                            },
                            attrs: { slot: "slac", "label-width": "100px" },
                            slot: "slac"
                          },
                          [
                            _c("line-label", {
                              class: _vm.elementDict.slac.isRequire
                                ? "blue"
                                : "",
                              attrs: {
                                slot: "label",
                                label: _vm.elementDict.slac.label
                              },
                              slot: "label"
                            }),
                            _c("el-input-number", {
                              class: _vm.importDifferenceField.slac
                                ? "red-border"
                                : "",
                              staticStyle: { width: "85px" },
                              attrs: {
                                disabled: !_vm.elementDict.slac.writable,
                                no: "slac",
                                min: 0,
                                precision: 0,
                                controls: false
                              },
                              on: {
                                change: function(p) {
                                  _vm.pm.slacChangeHandler(p)
                                }
                              },
                              model: {
                                value: _vm.job.slac,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "slac", $$v)
                                },
                                expression: "job.slac"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                : _vm._e(),
              _vm.elementDict.cargoEnglishName &&
              _vm.elementDict.cargoEnglishName.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      staticStyle: { width: "290px" },
                      attrs: { slot: "cargoEnglishName" },
                      slot: "cargoEnglishName"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.cargoEnglishName.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.cargoEnglishName.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-rich-textarea", {
                        attrs: {
                          "show-count": true,
                          no: "110",
                          type: "textarea",
                          rows: 5,
                          disabled:
                            _vm.viewStatus ||
                            !_vm.elementDict.cargoEnglishName.writable,
                          "english-letter-auto-uppercase":
                            _vm.isUppercaseByConfig
                        },
                        on: {
                          blur: function($event) {
                            return _vm.pm.cargoEnglishNameBlurHandler()
                          }
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.elementDict.cargoEnglishName.label,
                              _vm.job.cargoEnglishName,
                              function(val) {
                                _vm.pm.cargoEnglishNameChangeHandler(val)
                              },
                              _vm.isUppercaseByConfig,
                              { maxChar: 0 }
                            )
                          }
                        },
                        model: {
                          value: _vm.job.cargoEnglishName,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "cargoEnglishName", $$v)
                          },
                          expression: "job.cargoEnglishName"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.mark && _vm.elementDict.mark.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      staticStyle: { width: "290px" },
                      attrs: { slot: "mark" },
                      slot: "mark"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.mark.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.mark.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-rich-textarea", {
                        attrs: {
                          "show-count": true,
                          no: "111",
                          type: "textarea",
                          rows: 5,
                          disabled:
                            _vm.viewStatus || !_vm.elementDict.mark.writable,
                          "auto-uppercase": _vm.isUppercaseByConfig
                        },
                        on: {
                          blur: function($event) {
                            return _vm.pm.markBlurHandler()
                          }
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.elementDict.mark.label,
                              _vm.job.mark,
                              function(val) {
                                _vm.pm.markChangeHandler(val)
                              },
                              _vm.isUppercaseByConfig,
                              { maxChar: 0 }
                            )
                          }
                        },
                        model: {
                          value: _vm.job.mark,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "mark", $$v)
                          },
                          expression: "job.mark"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.cargoChineseName &&
              _vm.elementDict.cargoChineseName.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      staticStyle: { width: "290px" },
                      attrs: { slot: "cargoChineseName" },
                      slot: "cargoChineseName"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.cargoChineseName.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.cargoChineseName.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-rich-textarea", {
                        attrs: {
                          "show-count": true,
                          no: "112",
                          type: "textarea",
                          rows: 5,
                          disabled:
                            _vm.viewStatus ||
                            !_vm.elementDict.cargoChineseName.writable,
                          "auto-uppercase": true
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            return _vm.showAdvanceTextDialog(
                              _vm.elementDict.cargoChineseName.label,
                              _vm.job.cargoChineseName,
                              function(val) {
                                _vm.job.cargoChineseName = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.job.cargoChineseName,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "cargoChineseName", $$v)
                          },
                          expression: "job.cargoChineseName"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.specialOperationCode &&
              _vm.elementDict.specialOperationCode.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      staticStyle: { width: "290px" },
                      attrs: { slot: "specialOperationCode" },
                      slot: "specialOperationCode"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.specialOperationCode.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.specialOperationCode.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: _vm.job.specialOperationCode,
                            placement: "left"
                          }
                        },
                        [
                          _c("div", {
                            attrs: { slot: "content" },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.job.specialOperationCode ||
                                  _vm.$t("SeaExport.NoData")
                              )
                            },
                            slot: "content"
                          }),
                          _c("el-input", {
                            staticStyle: { height: "110px" },
                            attrs: {
                              no: "1211",
                              value: _vm.job.specialOperationCode,
                              placeholder: _vm.viewStatus
                                ? ""
                                : _vm.$t(
                                    "SeaExport.doubleClickToAddSpecialOperationCode"
                                  ),
                              rows: 6,
                              disabled: !_vm.elementDict.specialOperationCode
                                .writable,
                              type: "textarea"
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.selectSpecialOperationCodeDialog.value =
                                  _vm.job.specialOperationCode
                                _vm.selectSpecialOperationCodeDialog.visible = !_vm.viewStatus
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isFba
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "text-align": "left",
                        "margin-left": "20px"
                      }
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 4.8 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { "label-width": "80px" } },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "blue",
                                      attrs: { slot: "label" },
                                      slot: "label"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("FbaJob.ChargingMethod"))
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-radio-group",
                                    {
                                      attrs: { no: "chargingMethod" },
                                      on: { change: _vm.chargingMethodChange },
                                      model: {
                                        value: _vm.fbaJob.chargingMethod,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.fbaJob,
                                            "chargingMethod",
                                            $$v
                                          )
                                        },
                                        expression: "fbaJob.chargingMethod"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        { attrs: { label: "0" } },
                                        [_vm._v(_vm._s("KG"))]
                                      ),
                                      _c(
                                        "el-radio",
                                        { attrs: { label: "1" } },
                                        [_vm._v(_vm._s("CBM"))]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 4.8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.pbProportion"),
                                    "label-width": "80px"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { display: "flex" } },
                                    [
                                      _c("el-input", {
                                        attrs: { no: "bubbleSplittingRatio" },
                                        on: {
                                          change: _vm.bubbleSplittingRatioChange
                                        },
                                        model: {
                                          value:
                                            _vm.fbaJob.bubbleSplittingRatio,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.fbaJob,
                                              "bubbleSplittingRatio",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "fbaJob.bubbleSplittingRatio"
                                        }
                                      }),
                                      _vm._v("% ")
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 4.8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.pbProportion2"),
                                    "label-width": "80px"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { display: "flex" } },
                                    [
                                      _c("el-input-number", {
                                        staticStyle: { width: "90px" },
                                        attrs: {
                                          disabled: !_vm.elementDict
                                            .pbProportion2.writable,
                                          no: "108",
                                          "controls-position": "right",
                                          min: 0,
                                          max: 999999999
                                        },
                                        on: {
                                          input: function(val) {
                                            _vm.job.pbProportion2
                                          },
                                          change: function($event) {
                                            return _vm.pm.weightCubageChangeHandler(
                                              "pbProportion2"
                                            )
                                          }
                                        },
                                        model: {
                                          value: _vm.job.pbProportion2,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.job,
                                              "pbProportion2",
                                              $$v
                                            )
                                          },
                                          expression: "job.pbProportion2"
                                        }
                                      }),
                                      _c("span", [_vm._v("%")])
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 4.8 } },
                            [
                              _vm.isFba
                                ? _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "FbaChannel.bubbleCountingRatio"
                                        ),
                                        "label-width": "80px"
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "100%" },
                                        attrs: { no: "bubbleCountingRatio" },
                                        on: {
                                          change: _vm.bubbleCountingChange
                                        },
                                        model: {
                                          value: _vm.fbaJob.bubbleCountingRatio,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.fbaJob,
                                              "bubbleCountingRatio",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "fbaJob.bubbleCountingRatio"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { attrs: { slot: "codeSearching" }, slot: "codeSearching" },
                [
                  !_vm.isFba
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            no: "CodeSearching",
                            disabled: _vm.viewStatus,
                            type: "primary"
                          },
                          on: { click: _vm.codeSearch }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.CodeSearching")))]
                      )
                    : _vm._e(),
                  _vm.isFba
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            no: "FbaCodeSearching",
                            disabled: _vm.viewStatus,
                            type: "primary"
                          },
                          on: { click: _vm.fbaCodeSearchBtn }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.CodeSearching")))]
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-form",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.elementDict.shipper &&
                        _vm.elementDict.shipper.viewable,
                      expression:
                        "elementDict.shipper && elementDict.shipper.viewable"
                    }
                  ],
                  staticStyle: { "margin-right": "10px" },
                  attrs: {
                    slot: "shipper",
                    "label-width": "50px",
                    "label-position": "left"
                  },
                  slot: "shipper"
                },
                [
                  _c(
                    "el-form-item",
                    { staticClass: "custom" },
                    [
                      _c(
                        "template",
                        { slot: "label" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.shipper.isRequire
                              ? "blue"
                              : "",
                            attrs: { label: _vm.elementDict.shipper.label }
                          }),
                          _c("char-count", {
                            staticStyle: {
                              position: "static",
                              display: "block",
                              "font-size": "10px",
                              color: "#909399"
                            },
                            attrs: { form: _vm.job, prefix: "shipper" }
                          })
                        ],
                        1
                      ),
                      _c("cargo-input", {
                        class: _vm.importDifferenceField.shipperCode
                          ? "red-border"
                          : "",
                        staticStyle: { width: "110px", "margin-right": "5px" },
                        attrs: {
                          disabled:
                            _vm.viewStatus || !_vm.elementDict.shipper.writable,
                          no: "shipperCode",
                          "auto-uppercase":
                            _vm.notUppercaseShipperConsigneNotify
                        },
                        on: {
                          change: function(data) {
                            _vm.pm.shipperCodeChange(data)
                          }
                        },
                        model: {
                          value: _vm.job.shipperCode,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "shipperCode", $$v)
                          },
                          expression: "job.shipperCode"
                        }
                      }),
                      _c("cargo-company-select", {
                        class: _vm.importDifferenceField.shipperId
                          ? "red-border"
                          : "",
                        staticStyle: {
                          display: "inline-block",
                          width: "135px"
                        },
                        attrs: {
                          no: "113",
                          disabled:
                            _vm.viewStatus || !_vm.elementDict.shipper.writable,
                          "method-params": { shipper: true, active: true },
                          "default-value": _vm.job.shipperId || "",
                          fields: ["englishName"],
                          "tag-name": "englishName",
                          placeholder: " "
                        },
                        on: {
                          change: function(data) {
                            _vm.pm.shipperChange(data)
                          }
                        }
                      })
                    ],
                    2
                  ),
                  _vm._l(7, function(i) {
                    return _c(
                      "el-form-item",
                      { key: i, attrs: { "label-width": "0" } },
                      [
                        _c("cargo-input", {
                          ref: "shipperLine" + i,
                          refInFor: true,
                          class: _vm.importDifferenceField["shipperLine" + i]
                            ? "red-border"
                            : "",
                          attrs: {
                            disabled:
                              _vm.viewStatus ||
                              !_vm.elementDict.shipper.writable,
                            no: "shipperLine" + i,
                            "auto-uppercase":
                              _vm.notUppercaseShipperConsigneNotify,
                            "use-read-only": true
                          },
                          on: {
                            change: function() {
                              return _vm.wrapAddr(
                                _vm.job,
                                "shipperLine" + i,
                                i + 1 > 7 ? null : "shipperLine" + (i + 1),
                                200
                              )
                            }
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.elementDict.shipper.label,
                                _vm.mergeShipperLine(),
                                _vm.splitShipperLine,
                                _vm.notUppercaseShipperConsigneNotify
                              )
                            }
                          },
                          model: {
                            value: _vm.job["shipperLine" + i],
                            callback: function($$v) {
                              _vm.$set(_vm.job, "shipperLine" + i, $$v)
                            },
                            expression: "job['shipperLine'+i]"
                          }
                        })
                      ],
                      1
                    )
                  })
                ],
                2
              ),
              _c(
                "el-form",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.elementDict.consignee &&
                        _vm.elementDict.consignee.viewable,
                      expression:
                        "elementDict.consignee && elementDict.consignee.viewable"
                    }
                  ],
                  staticStyle: { "margin-right": "20px" },
                  attrs: {
                    slot: "consignee",
                    "label-width": "50px",
                    "label-position": "left"
                  },
                  slot: "consignee"
                },
                [
                  _c(
                    "el-form-item",
                    { staticClass: "custom" },
                    [
                      _c(
                        "template",
                        { slot: "label" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.consignee.isRequire
                              ? "blue"
                              : "",
                            attrs: { label: _vm.elementDict.consignee.label }
                          }),
                          _c("char-count", {
                            staticStyle: {
                              position: "static",
                              display: "block",
                              "font-size": "10px",
                              color: "#909399"
                            },
                            attrs: { form: _vm.job, prefix: "consignee" }
                          })
                        ],
                        1
                      ),
                      _c("cargo-input", {
                        class: _vm.importDifferenceField.consigneeCode
                          ? "red-border"
                          : "",
                        staticStyle: { width: "110px", "margin-right": "5px" },
                        attrs: {
                          disabled:
                            _vm.viewStatus ||
                            !_vm.elementDict.consignee.writable,
                          no: "consigneeCode",
                          "auto-uppercase":
                            _vm.notUppercaseShipperConsigneNotify
                        },
                        on: {
                          change: function(data) {
                            _vm.pm.consigneeCodeChange(data)
                          }
                        },
                        model: {
                          value: _vm.job.consigneeCode,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "consigneeCode", $$v)
                          },
                          expression: "job.consigneeCode"
                        }
                      }),
                      _c("cargo-company-select", {
                        class: _vm.importDifferenceField.consigneeId
                          ? "red-border"
                          : "",
                        staticStyle: {
                          display: "inline-block",
                          width: "135px"
                        },
                        attrs: {
                          no: "115",
                          disabled:
                            _vm.viewStatus ||
                            !_vm.elementDict.consignee.writable,
                          "method-params": { consignee: true, active: true },
                          "default-value": _vm.job.consigneeId || "",
                          fields: ["englishName"],
                          "tag-name": "englishName",
                          placeholder: " "
                        },
                        on: {
                          change: function(data) {
                            _vm.pm.consigneeChange(data)
                          }
                        }
                      })
                    ],
                    2
                  ),
                  _vm._l(7, function(i) {
                    return _c(
                      "el-form-item",
                      { key: i, attrs: { "label-width": "0" } },
                      [
                        _c("cargo-input", {
                          ref: "consigneeLine" + i,
                          refInFor: true,
                          class: _vm.importDifferenceField["consigneeLine" + i]
                            ? "red-border"
                            : "",
                          attrs: {
                            disabled:
                              _vm.viewStatus ||
                              !_vm.elementDict.consignee.writable,
                            no: "consigneeLine" + i,
                            "auto-uppercase":
                              _vm.notUppercaseShipperConsigneNotify,
                            "use-read-only": true
                          },
                          on: {
                            change: function() {
                              return _vm.wrapAddr(
                                _vm.job,
                                "consigneeLine" + i,
                                i + 1 > 7 ? null : "consigneeLine" + (i + 1),
                                200
                              )
                            }
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.elementDict.consignee.label,
                                _vm.mergeConsigneeLine(),
                                _vm.splitConsigneeLine,
                                _vm.notUppercaseShipperConsigneNotify
                              )
                            }
                          },
                          model: {
                            value: _vm.job["consigneeLine" + i],
                            callback: function($$v) {
                              _vm.$set(_vm.job, "consigneeLine" + i, $$v)
                            },
                            expression: "job['consigneeLine'+i]"
                          }
                        })
                      ],
                      1
                    )
                  })
                ],
                2
              ),
              _c(
                "el-form",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.elementDict.notify &&
                        _vm.elementDict.notify.viewable,
                      expression:
                        "elementDict.notify && elementDict.notify.viewable"
                    }
                  ],
                  staticStyle: { "margin-right": "20px" },
                  attrs: {
                    slot: "notify",
                    "label-width": "50px",
                    "label-position": "left"
                  },
                  slot: "notify"
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.NotifyParty") }
                    },
                    [
                      _c(
                        "template",
                        { slot: "label" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.notify.isRequire
                              ? "blue"
                              : "",
                            attrs: { label: _vm.elementDict.notify.label }
                          }),
                          _c("char-count", {
                            staticStyle: {
                              position: "static",
                              display: "block",
                              "font-size": "10px",
                              color: "#909399"
                            },
                            attrs: { form: _vm.job, prefix: "notify" }
                          })
                        ],
                        1
                      ),
                      _c("cargo-input", {
                        class: _vm.importDifferenceField.notifyCode
                          ? "red-border"
                          : "",
                        staticStyle: { width: "110px", "margin-right": "5px" },
                        attrs: {
                          disabled:
                            _vm.viewStatus || !_vm.elementDict.notify.writable,
                          no: "notifyCode",
                          "auto-uppercase":
                            _vm.notUppercaseShipperConsigneNotify
                        },
                        on: {
                          change: function(data) {
                            _vm.pm.notifyCodeChange(data)
                          }
                        },
                        model: {
                          value: _vm.job.notifyCode,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "notifyCode", $$v)
                          },
                          expression: "job.notifyCode"
                        }
                      }),
                      _c("cargo-company-select", {
                        class: _vm.importDifferenceField.notifyId
                          ? "red-border"
                          : "",
                        staticStyle: {
                          display: "inline-block",
                          width: "135px"
                        },
                        attrs: {
                          no: "117",
                          disabled:
                            _vm.viewStatus || !_vm.elementDict.notify.writable,
                          "method-params": { notify: true, active: true },
                          "default-value": _vm.job.notifyId || "",
                          fields: ["englishName"],
                          "tag-name": "englishName",
                          placeholder: " "
                        },
                        on: {
                          change: function(data) {
                            _vm.pm.notifyChange(data)
                          }
                        }
                      })
                    ],
                    2
                  ),
                  _vm._l(7, function(i) {
                    return _c(
                      "el-form-item",
                      { key: i, attrs: { "label-width": "0" } },
                      [
                        _c("cargo-input", {
                          ref: "notifyLine" + i,
                          refInFor: true,
                          class: _vm.importDifferenceField["notifyLine" + i]
                            ? "red-border"
                            : "",
                          attrs: {
                            disabled:
                              _vm.viewStatus ||
                              !_vm.elementDict.notify.writable,
                            no: "notifyLine" + i,
                            "auto-uppercase":
                              _vm.notUppercaseShipperConsigneNotify,
                            "use-read-only": true
                          },
                          on: {
                            change: function() {
                              return _vm.wrapAddr(
                                _vm.job,
                                "notifyLine" + i,
                                i + 1 > 7 ? null : "notifyLine" + (i + 1),
                                200
                              )
                            }
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.elementDict.notify.label,
                                _vm.mergeNotifyLine(),
                                _vm.splitNotifyLine,
                                _vm.notUppercaseShipperConsigneNotify
                              )
                            }
                          },
                          model: {
                            value: _vm.job["notifyLine" + i],
                            callback: function($$v) {
                              _vm.$set(_vm.job, "notifyLine" + i, $$v)
                            },
                            expression: "job['notifyLine'+i]"
                          }
                        })
                      ],
                      1
                    )
                  })
                ],
                2
              ),
              _vm.elementDict.alsoNotify && _vm.elementDict.alsoNotify.viewable
                ? _c(
                    "div",
                    { attrs: { slot: "alsoNotify" }, slot: "alsoNotify" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.alsoNotify.isRequire
                          ? "blue"
                          : "",
                        staticStyle: {
                          display: "inline-block",
                          "line-height": "28px",
                          "padding-bottom": "5px"
                        },
                        attrs: { label: _vm.elementDict.alsoNotify.label }
                      }),
                      _c("br"),
                      _c("cargo-textarea", {
                        staticClass: "also-notify",
                        class: _vm.importDifferenceField.alsoNotify
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "119",
                          type: "textarea",
                          rows: 5,
                          disabled:
                            _vm.viewStatus ||
                            !_vm.elementDict.alsoNotify.writable
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            return _vm.showAdvanceTextDialog(
                              _vm.elementDict.alsoNotify.label,
                              _vm.job.alsoNotify,
                              function(val) {
                                _vm.job.alsoNotify = val
                              },
                              _vm.notUppercaseShipperConsigneNotify,
                              { maxChar: 0 }
                            )
                          }
                        },
                        model: {
                          value: _vm.job.alsoNotify,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "alsoNotify", $$v)
                          },
                          expression: "job.alsoNotify"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.rateType && _vm.elementDict.rateType.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "rateType" }, slot: "rateType" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.rateType.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.rateType.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "el-select",
                        {
                          attrs: {
                            disabled:
                              _vm.viewStatus ||
                              !_vm.elementDict.rateType.writable,
                            no: "rateType",
                            clearable: "",
                            placeholder: _vm.$t("SeaExport.PleaseSelect"),
                            size: "mini"
                          },
                          model: {
                            value: _vm.job.rateType,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "rateType", $$v)
                            },
                            expression: "job.rateType"
                          }
                        },
                        _vm._l(_vm.rateType, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.isZh
                                ? item.chineseName
                                : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          )
        ],
        1
      ),
      _vm.showContactsInfoDialog
        ? _c("cargo-contacts-info-dialog", {
            attrs: {
              visible: _vm.showContactsInfoDialog,
              "customer-id": _vm.job.customerId,
              "customer-contact": _vm.job.customerContact
            },
            on: {
              "update:visible": function($event) {
                _vm.showContactsInfoDialog = $event
              }
            }
          })
        : _vm._e(),
      _c("transit-port-dialog", {
        attrs: {
          visible: _vm.transitPortDialog.visible,
          job: _vm.transitPortDialog.job
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.transitPortDialog, "visible", $event)
          },
          enter: _vm.transitPortDialogCallback
        }
      }),
      _c("select-mawb-dialog", {
        attrs: {
          visible: _vm.selectMawbDialog.visible,
          type: _vm.selectMawbDialog.type,
          "operate-type": _vm.selectMawbDialog.operateType,
          "carrier-id": _vm.selectMawbDialog.carrierId
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.selectMawbDialog, "visible", $event)
          },
          enterEvent: _vm.selectedMAWBHandler
        }
      }),
      _vm.selectOperationReqDialog.visible
        ? _c("select-operation-req-dialog", {
            attrs: {
              visible: _vm.selectOperationReqDialog.visible,
              lob: "AE",
              value: _vm.selectOperationReqDialog.value
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.selectOperationReqDialog, "visible", $event)
              },
              callback: function(val) {
                _vm.job.operationContent = val
                this$1.pm.syncDocHandlingInfo()
              }
            }
          })
        : _vm._e(),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            },
            close: _vm.closeAdvanceText
          }
        },
        [
          _c("cargo-rich-textarea", {
            staticStyle: { height: "320px" },
            attrs: {
              disabled: _vm.viewStatus,
              "text-chars": _vm.advanceTextDialog.formatObj.maxChar,
              "warning-count": _vm.advanceTextDialog.formatObj.warningCount,
              no: "144"
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.viewStatus,
                      expression: "!viewStatus"
                    }
                  ],
                  attrs: { no: "120", type: "primary" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "121" },
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                      _vm.closeAdvanceText()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("sop-dialog", {
        attrs: {
          visible: _vm.sopDialog.visible,
          "cmp-idx": _vm.sopDialog.cmpIdx,
          job: _vm.job,
          agent: _vm.sopDialog.agent,
          lob: "AE",
          "contact-list": _vm.sopDialog.contactList
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.sopDialog, "visible", $event)
          },
          updateJob: function($event) {
            return _vm.$emit("updateJob")
          }
        }
      }),
      _c("bill-address-dialog", {
        attrs: {
          visible: _vm.billAddressDialog.visible,
          job: _vm.billAddressDialog.job,
          params: _vm.billAddressDialog.params
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.billAddressDialog, "visible", $event)
          },
          callback: _vm.codeSearchCallback
        }
      }),
      _c("ware-house-dialog", {
        attrs: {
          visible: _vm.warehouseDialog.visible,
          job: _vm.warehouseDialog.job
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.warehouseDialog, "visible", $event)
          },
          warehouseCommitCallback: _vm.warehouseCommitCallback
        }
      }),
      _c("stamp-picture-view", {
        attrs: {
          visible: _vm.stampPictureView.visible,
          "business-documents": _vm.stampPictureView.businessDocuments
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.stampPictureView, "visible", $event)
          }
        }
      }),
      _c("fba-bill-address-dialog", {
        attrs: { visible: _vm.fbaBillAddressDialog.visible, job: _vm.fbaJob },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.fbaBillAddressDialog, "visible", $event)
          },
          callback: _vm.fbaCodeSearchCallback
        }
      }),
      _vm.dimensionsDialog.visible
        ? _c("common-dimensions-dialog", {
            attrs: {
              visible: _vm.dimensionsDialog.visible,
              "open-imperial": _vm.openImperial
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.dimensionsDialog, "visible", $event)
              },
              sizeData: _vm.sizeDataHandler,
              close: function($event) {
                _vm.dimensionsDialog.visible = false
              }
            }
          })
        : _vm._e(),
      _vm.selectSpecialOperationCodeDialog.visible
        ? _c("select-special-operation-code-dialog", {
            attrs: {
              visible: _vm.selectSpecialOperationCodeDialog.visible,
              lob: "AE",
              value: _vm.selectSpecialOperationCodeDialog.value
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(
                  _vm.selectSpecialOperationCodeDialog,
                  "visible",
                  $event
                )
              },
              callback: function(val) {
                _vm.job.specialOperationCode = val
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }